/* हिन्दी. Generated from the Hindi translation (scripts/i18n/hindi); don't edit by hand. Translated from the English. */
import type { Dict } from './en';

export const hi: Dict = {
  "company.privacyEmail": "hello@pathsabroad.com",
  "company.supportEmail": "hello@pathsabroad.com",
  "app.skip": "मुख्य सामग्री पर जाएँ",
  "app.home": "PathsAbroad होम पेज",
  "lang.label": "भाषा",
  "nav.sections": "खाते के सेक्शन",
  "nav.overview": "सारांश",
  "nav.profile": "प्रोफ़ाइल",
  "nav.inbox": "आवेदन इनबॉक्स",
  "nav.plans": "प्लान",
  "nav.extension": "Chrome एक्सटेंशन",
  "nav.security": "साइन-इन और सुरक्षा",
  "nav.data": "आपका डेटा",
  "nav.account": "खाता",
  "nav.planner": "प्लानर खोलें",
  "nav.signin": "साइन इन करें",
  "nav.signout": "साइन आउट करें",
  "footer.privacy": "गोपनीयता",
  "footer.terms": "नियम और शर्तें",
  "footer.note": "कोई विज्ञापन नहीं, कोई ट्रैकिंग नहीं। सिर्फ़ वे कुकी, जो आपको साइन इन रखती हैं।",
  "common.loading": "लोड हो रहा है…",
  "common.retry": "फिर से कोशिश करें",
  "common.continue": "जारी रखें",
  "common.cancel": "रद्द करें",
  "common.save": "बदलाव सेव करें",
  "common.saving": "सेव हो रहा है…",
  "common.copied": "कॉपी हो गया",
  "common.copyFailed": "कॉपी नहीं हो सका। टेक्स्ट चुनें और खुद कॉपी करें।",
  "common.show": "दिखाएँ",
  "common.hide": "छिपाएँ",
  "common.showPassword": "पासवर्ड दिखाएँ",
  "common.hidePassword": "पासवर्ड छिपाएँ",
  "common.optional": "वैकल्पिक",
  "common.choose": "चुनें…",
  "common.remove": "हटाएँ",
  "common.removeNamed": "{name} हटाएँ",
  "common.email": "ईमेल",
  "common.password": "पासवर्ड",
  "common.on": "चालू",
  "common.off": "बंद",
  "common.opensNew": "(नए टैब में खुलता है)",
  "common.home": "होम पेज पर जाएँ",
  "session.checking": "आपका सेशन जाँचा जा रहा है…",
  "session.error": "आपका सेशन जाँचने के लिए हम PathsAbroad तक नहीं पहुँच सके।",
  "err.bad_credentials": "यह ईमेल और पासवर्ड मेल नहीं खाते। फिर से कोशिश करें, या अपना पासवर्ड रीसेट करें।",
  "err.email_not_confirmed": "पहले हमारा भेजा हुआ 6 अंकों का कोड टाइप करके अपना ईमेल कन्फ़र्म करें।",
  "err.bad_code": "इस कोड ने काम नहीं किया। इसे जाँचें और फिर से कोशिश करें, या नया कोड पाएँ।",
  "err.already_paid": "इस सीज़न के लिए यह पास आपके पास पहले से है।",
  "err.withdrawal_ack_required": "यह मानने के लिए बॉक्स पर टिक करें कि सारी बिक्री अंतिम है, फिर दोबारा कोशिश करें।",
  "err.version_conflict": "यह कहीं और बदल गया है। सबसे नया वर्शन देखने के लिए पेज रीलोड करें।",
  "err.invalid": "कुछ जानकारी जाँचनी होगी। हाइलाइट किया गया फ़ील्ड देखें।",
  "err.not_found": "हमें यह नहीं मिला। हो सकता है इसे हटा दिया गया हो।",
  "err.rate_limited": "बहुत ज़्यादा कोशिशें हो गईं। कुछ मिनट रुकें, फिर दोबारा कोशिश करें।",
  "err.forbidden": "यह आपके खाते के लिए उपलब्ध नहीं है।",
  "err.network": "PathsAbroad से कनेक्ट नहीं हो पा रहा है। अपना कनेक्शन जाँचें और फिर से कोशिश करें।",
  "err.server_error": "हमारी तरफ़ से कुछ गड़बड़ हो गई। एक मिनट बाद फिर से कोशिश करें।",
  "err.signed_out": "आपका सेशन खत्म हो गया है। फिर से साइन इन करें।",
  "err.mfa_required": "पहले अपना दो-चरणीय साइन-इन कोड टाइप करें।",
  "err.guardian_consent_required": "पहले माता-पिता या अभिभावक को आपके खाते को मंज़ूरी देनी होगी।",
  "err.plan_required": "इसके लिए आवेदन और आगमन पास ज़रूरी है।",
  "v.email": "ईमेल पता डालें, जैसे name@example.com.",
  "v.password": "कम से कम 10 कैरेक्टर इस्तेमाल करें।",
  "v.passwordMatch": "दोनों पासवर्ड मेल नहीं खाते।",
  "v.code": "6 अंकों का कोड डालें।",
  "v.required": "यह फ़ील्ड भरें।",
  "v.tick": "जारी रखने के लिए इस बॉक्स पर टिक करें।",
  "v.choose": "कोई विकल्प चुनें।",
  "pw.hint": "कम से कम 10 कैरेक्टर। छोटा-सा वाक्य याद रखना आसान होता है और उसका अंदाज़ा लगाना मुश्किल।",
  "pw.strength": "मज़बूती: {level}",
  "pw.too_short": "बहुत छोटा",
  "pw.weak": "कमज़ोर",
  "pw.fair": "ठीक-ठाक",
  "pw.strong": "मज़बूत",
  "home.title": "विदेश में पढ़ाई, एक-एक कदम साफ़-साफ़।",
  "home.lead": "PathsAbroad आपके लिए सही विश्वविद्यालय ढूँढने, अपनी शर्तों पर आवेदन करने, आधिकारिक जानकारी के साथ वीज़ा की तैयारी करने और वहाँ सेटल होने में आपकी मदद करता है।",
  "home.start": "अपने विश्वविद्यालय खोजें",
  "home.signin": "साइन इन करें",
  "home.planner": "प्लानर खोलें",
  "home.pathTitle": "आपका रास्ता",
  "home.step0.text": "अपने बारे में एक बार बताएँ। आपकी जानकारी आपकी ही रहती है: उसे कभी भी डाउनलोड करें या हटाएँ।",
  "home.step1.text": "कोई भी विश्वविद्यालय चुनें, उन्हें भी जिनका सुझाव हमने नहीं दिया। हर आवेदन आप खुद जमा करते हैं और हर फ़ीस खुद भरते हैं।",
  "home.step2.text": "प्रवेश से जुड़े ईमेल छँटकर एक ही इनबॉक्स में आते हैं, और अगले कदम आपके लिए अलग से निकाल दिए जाते हैं।",
  "home.step3.text": "आधिकारिक स्रोतों से वीज़ा चेकलिस्ट, साथ ही रहने की जगह और आपके शुरुआती हफ़्ते। सामान्य जानकारी, इमिग्रेशन या कानूनी सलाह नहीं।",
  "phase.0": "प्रोफ़ाइल",
  "phase.1": "आवेदन",
  "phase.2": "प्रवेश",
  "phase.3": "आगमन",
  "phase.here": "आप यहाँ हैं",
  "phase.done": "पूरा हुआ",
  "phase.summary": "4 में से चरण {n}: {name}",
  "auth.step": "{total} में से चरण {n}",
  "auth.saveList": "अपनी सूची सेव करें",
  "auth.beginWith": "शुरुआत {school} से",
  "auth.welcomeBack": "फिर से स्वागत है",
  "start.dob.title": "आपका जन्म कब हुआ?",
  "start.dob.day": "दिन",
  "start.dob.month": "महीना",
  "start.dob.year": "साल",
  "dob.missing": "दिन, महीना और साल चुनें।",
  "dob.no_such_day": "यह तारीख मौजूद नहीं है। दिन और महीना जाँचें।",
  "dob.check": "अपनी जन्म तिथि जाँचें।",
  "start.blocked.title": "माफ़ करें, हम आपके लिए PathsAbroad खाता नहीं बना सकते।",
  "start.form.title": "अपना खाता बनाएँ",
  "start.form.emailHint": "यह ईमेल आपका ही है, यह जाँचने के लिए हम एक कोड भेजेंगे।",
  "start.form.lang": "भाषा",
  "start.form.langHint": "ऐप के लिए, और उन ईमेल के लिए जो हम आपको भेजते हैं।",
  "start.form.minor": "अपनी जानकारी सेव कर पाने से पहले, माता-पिता या अभिभावक को आपके खाते को मंज़ूरी देनी होगी।",
  "start.form.agree": "खाता बनाकर, आप {terms} स्वीकार करते हैं और पुष्टि करते हैं कि आपने {privacy} पढ़ ली है।",
  "start.form.termsLink": "नियम और शर्तें",
  "start.form.privacyLink": "गोपनीयता सूचना",
  "start.form.submit": "खाता बनाएँ",
  "start.form.changeDob": "जन्म तिथि बदलें",
  "start.haveAccount": "क्या आपका खाता पहले से है?",
  "verify.title": "अपना ईमेल देखें",
  "verify.sent": "हमने {email} पर 6 अंकों का कोड भेजा है। इसे आने में एक मिनट लग सकता है।",
  "verify.noEmail": "वह ईमेल टाइप करें जिससे आपने साइन अप किया था, और हमारा भेजा हुआ 6 अंकों का कोड भी।",
  "verify.code": "6 अंकों का कोड",
  "verify.submit": "ईमेल वेरिफ़ाई करें",
  "verify.resend": "नया कोड भेजें",
  "verify.resendIn": "{time} बाद नया कोड भेजें",
  "verify.resent": "हमने {email} पर नया कोड भेजा है।",
  "verify.rateLimited": "आपने कई कोड माँगे हैं। फिर से माँगने से पहले कुछ मिनट रुकें।",
  "verify.noResend": "नया कोड पाने के लिए फिर से शुरू करें। हम आपकी साइन-अप जानकारी इस ब्राउज़र में नहीं रखते।",
  "verify.startAgain": "फिर से शुरू करें",
  "callback.title": "आपको साइन इन किया जा रहा है",
  "callback.working": "एक पल रुकें…",
  "callback.failed": "इस साइन-इन लिंक ने काम नहीं किया। हो सकता है इसकी समय-सीमा खत्म हो गई हो या इसका इस्तेमाल पहले ही हो चुका हो।",
  "callback.signin": "साइन इन पर जाएँ",
  "signin.title": "साइन इन करें",
  "signin.forgot": "पासवर्ड याद नहीं है?",
  "signin.new": "क्या आपका खाता नहीं है?",
  "signin.create": "खाता बनाएँ",
  "signin.enterCode": "अपना कोड डालें",
  "code.title": "अपना साइन-इन कोड डालें",
  "code.lead": "अपना ऑथेंटिकेटर ऐप खोलें और उसमें PathsAbroad के लिए दिख रहा 6 अंकों का कोड टाइप करें।",
  "code.label": "6 अंकों का कोड",
  "code.switch": "दूसरा खाता इस्तेमाल करें",
  "code.help": "फ़ोन खो गया? जिस ईमेल पते से आपने साइन अप किया था, उससे {email} पर ईमेल करें।",
  "reset.title": "अपना पासवर्ड रीसेट करें",
  "reset.lead": "PathsAbroad के लिए इस्तेमाल होने वाला ईमेल टाइप करें। हम आपको 6 अंकों का कोड भेजेंगे।",
  "reset.send": "कोड भेजें",
  "reset.sent": "अगर {email} के लिए कोई खाता है, तो हमने उस पर 6 अंकों का कोड भेज दिया है।",
  "reset.newPassword": "नया पासवर्ड",
  "reset.submit": "नया पासवर्ड सेट करें",
  "reset.otherEmail": "दूसरा ईमेल इस्तेमाल करें",
  "reset.back": "साइन इन पर वापस जाएँ",
  "gn.title": "माता-पिता या अभिभावक को हाँ कहना होगा",
  "gn.lead": "आपकी उम्र 18 साल से कम है, इसलिए PathsAbroad आपकी प्रोफ़ाइल, विश्वविद्यालयों की सूची या दस्तावेज़ जैसी आपके बारे में कोई भी जानकारी सेव करे, उससे पहले माता-पिता या अभिभावक की सहमति ज़रूरी है।",
  "gn.whatTitle": "उनकी सहमति किन बातों के लिए है",
  "gn.what1": "PathsAbroad आपकी प्रोफ़ाइल सेव कर सकता है और आपके आवेदनों में मदद के लिए उसका इस्तेमाल कर सकता है।",
  "gn.what2": "आप प्लानर, आवेदन इनबॉक्स और Chrome एक्सटेंशन इस्तेमाल कर सकते हैं।",
  "gn.what3": "जब तक आपकी उम्र 18 साल से कम है, हम धर्म या पारिवारिक आय जैसी संवेदनशील जानकारी नहीं माँगेंगे।",
  "gn.howTitle": "यह कैसे काम करता है",
  "gn.how1": "नीचे टाइप किए गए पते पर हम एक लिंक ईमेल करते हैं।",
  "gn.how2": "उस पेज पर बताया गया है कि हम क्या जानकारी रखते हैं और क्यों। वे सहमति दे सकते हैं या मना कर सकते हैं।",
  "gn.how3": "अगर वे सहमति देते हैं, तो आपका खाता पूरी तरह खुल जाता है। वे बाद में अपना फ़ैसला बदल सकते हैं, और ऐसा करने पर आपका खाता हट जाता है।",
  "gn.whyTitle": "हम क्यों पूछते हैं",
  "gn.why": "कई देशों के कानून ऑनलाइन 18 साल से कम उम्र के लोगों की सुरक्षा करते हैं। माता-पिता या अभिभावक से पूछने से आप दोनों को पूरी जानकारी रहती है।",
  "gn.formTitle": "अनुरोध भेजें",
  "gn.email": "माता-पिता या अभिभावक का ईमेल",
  "gn.lang": "उनके ईमेल की भाषा",
  "gn.submit": "अनुरोध भेजें",
  "gn.sameEmail": "अपने माता-पिता या अभिभावक का खुद का ईमेल इस्तेमाल करें, अपना नहीं।",
  "gn.sent": "{email} पर अनुरोध भेजा गया।",
  "gn.rateLimited": "आप एक दिन में ज़्यादा से ज़्यादा 3 अनुरोध भेज सकते हैं। कल फिर से कोशिश करें।",
  "gn.pending.title": "जवाब का इंतज़ार है",
  "gn.pending.text": "हमने आपके माता-पिता या अभिभावक को ईमेल किया है। लिंक 14 दिनों तक काम करता है, और यह पेज अपने-आप अपडेट होता है।",
  "gn.check": "अभी जाँचें",
  "gn.resend": "फिर से भेजें",
  "gn.granted.title": "आपके माता-पिता या अभिभावक ने हाँ कहा",
  "gn.granted.text": "आपका खाता तैयार है। अब आप अपनी प्रोफ़ाइल सेव कर सकते हैं और PathsAbroad की हर सुविधा इस्तेमाल कर सकते हैं।",
  "gn.granted.go": "अपने खाते पर जाएँ",
  "gn.denied.title": "आपके माता-पिता या अभिभावक ने मना कर दिया",
  "gn.denied.text": "आप उनसे बात करके नया अनुरोध भेज सकते हैं, या किसी दूसरे माता-पिता या अभिभावक से पूछ सकते हैं।",
  "gn.expired.title": "लिंक की समय-सीमा खत्म हो गई",
  "gn.expired.text": "14 दिनों के अंदर किसी ने जवाब नहीं दिया। आप नीचे नया अनुरोध भेज सकते हैं।",
  "gn.revoked.title": "सहमति वापस ले ली गई",
  "gn.revoked.text": "आपके माता-पिता या अभिभावक ने अपनी सहमति वापस ले ली।",
  "gn.limited": "तब तक, आप हमारी गोपनीयता सूचना तथा नियम और शर्तें पढ़ सकते हैं, या साइन आउट कर सकते हैं।",
  "gc.title": "एक विद्यार्थी ने आपकी मंज़ूरी माँगी है",
  "gc.lead": "{student} PathsAbroad इस्तेमाल करना चाहते हैं। उनकी उम्र 18 साल से कम है, इसलिए हमें पहले माता-पिता या कानूनी अभिभावक की सहमति चाहिए।",
  "gc.aboutTitle": "PathsAbroad क्या है",
  "gc.about": "PathsAbroad विद्यार्थियों को विदेश में विश्वविद्यालय चुनने, अपने आवेदन तैयार करने, आधिकारिक स्रोतों की जानकारी के साथ वीज़ा की तैयारी करने और वहाँ सेटल होने में मदद करता है। विद्यार्थी हर आवेदन खुद जमा करते हैं और विश्वविद्यालय की कोई भी फ़ीस खुद भरते हैं। PathsAbroad कोई विश्वविद्यालय, एजेंट या इमिग्रेशन सलाहकार नहीं है।",
  "gc.storeTitle": "हम विद्यार्थी के बारे में क्या जानकारी रखते हैं",
  "gc.store1": "आवेदनों के लिए उनकी प्रोफ़ाइल: नाम, जन्म तिथि, नागरिकता, संपर्क जानकारी, शिक्षा संस्थान और ग्रेड, परिवार की जानकारी और पढ़ाई की योजनाएँ। जन्म तिथि, नागरिकता और कोई भी पासपोर्ट नंबर एन्क्रिप्ट करके रखे जाते हैं।",
  "gc.store2": "जातीयता, धर्म या पारिवारिक आय जैसी संवेदनशील जानकारी: 18 साल से कम उम्र में कभी नहीं। 18 साल के होने के बाद, वे चाहें तो इनमें से हर जानकारी अलग से जोड़ सकते हैं, सिर्फ़ छात्रवृत्ति मिलान के लिए।",
  "gc.store3": "इनबॉक्स सारांश: अगर वे अपना PathsAbroad आवेदन इनबॉक्स इस्तेमाल करते हैं, तो हम प्रवेश से जुड़े ईमेल के छोटे सारांश रखते हैं। पूरे मैसेज तब तक रखे जाते हैं जब तक उनका पास चालू है, और कम से कम 30 दिन, फिर हटा दिए जाते हैं।",
  "gc.store4": "भुगतान: अगर कोई पेड प्लान खरीदा जाता है, तो कार्ड की जानकारी Stripe संभालता है। हम कार्ड नंबर कभी नहीं देखते।",
  "gc.store5": "कोई विज्ञापन नहीं, कोई ट्रैकिंग नहीं, और हम कभी डेटा नहीं बेचते।",
  "gc.rightsTitle": "आपके अधिकार",
  "gc.rights1": "{email} पर ईमेल करके विद्यार्थी का डेटा देखें या डाउनलोड करें, या हमसे उसे ठीक करने या हटाने के लिए कहें।",
  "gc.rights2": "अपनी सहमति कभी भी वापस लें। आपके सहमति देने के बाद, हम इसके लिए आपको एक अलग लिंक ईमेल करेंगे। सहमति वापस लेने पर विद्यार्थी का खाता और डेटा हट जाता है।",
  "gc.rights3": "अगर आपको लगता है कि हमसे कुछ गलत हुआ है, तो अपने डेटा सुरक्षा प्राधिकरण से शिकायत करें।",
  "gc.formTitle": "आपका फ़ैसला",
  "gc.name": "आपका पूरा नाम",
  "gc.relationship": "विद्यार्थी से आपका रिश्ता",
  "gc.confirm": "मैं इस विद्यार्थी के माता-पिता में से एक या कानूनी अभिभावक हूँ और मेरी उम्र 18 साल या उससे ज़्यादा है",
  "gc.agree": "सहमति दें",
  "gc.decline": "मना करें",
  "gc.ignore": "आप सही व्यक्ति नहीं हैं? आप इस अनुरोध को अनदेखा कर सकते हैं। इसकी समय-सीमा {date} को खत्म होगी।",
  "gc.missing": "इस पेज के लिए हमारे भेजे हुए ईमेल का लिंक ज़रूरी है।",
  "gc.invalid.title": "यह लिंक मान्य नहीं है",
  "gc.invalid.text": "हो सकता है इसकी जगह कोई नया अनुरोध आ गया हो। विद्यार्थी से नया अनुरोध भेजने के लिए कहें।",
  "gc.granted.title": "धन्यवाद। आपने सहमति दी।",
  "gc.granted.text": "{student} अब PathsAbroad इस्तेमाल कर सकते हैं। हमने आपको एक अलग लिंक ईमेल किया है, जिससे आप कभी भी सहमति वापस ले सकते हैं।",
  "gc.denied.title": "आपने मना कर दिया",
  "gc.denied.text": "PathsAbroad विद्यार्थी के बारे में अब और कुछ नहीं रखेगा। विद्यार्थी का खाता तब तक सीमित रहेगा, जब तक कोई माता-पिता या अभिभावक सहमति नहीं देते।",
  "gc.already.granted": "आपने इस अनुरोध पर पहले ही सहमति दे दी है। सहमति वापस लेने के लिए, आपकी सहमति के बाद हमने जो ईमेल भेजा था, उसमें दिया गया लिंक इस्तेमाल करें।",
  "gc.already.denied": "आपने इस अनुरोध के लिए पहले ही मना कर दिया है।",
  "gc.already.expired": "इस अनुरोध की समय-सीमा खत्म हो गई है। विद्यार्थी नया अनुरोध भेज सकते हैं।",
  "gc.already.revoked": "इस खाते के लिए सहमति वापस ले ली गई है।",
  "gw.title": "अपनी सहमति वापस लें",
  "gw.lead": "अगर आप सहमति वापस लेते हैं, तो हम विद्यार्थी का PathsAbroad खाता और उनका सारा डेटा हटा देते हैं: प्रोफ़ाइल, विश्वविद्यालयों की सूची, निबंध, आवेदन इनबॉक्स, मैसेज और टास्क। इसे पहले जैसा नहीं किया जा सकता।",
  "gw.kept": "Stripe किसी भी भुगतान का रिकॉर्ड तब तक रखता है, जब तक टैक्स कानून के तहत ज़रूरी हो। हम एक रिकॉर्ड रखते हैं कि खाता हटाया गया था, जिसमें कोई निजी जानकारी नहीं होती।",
  "gw.confirm": "मैंने समझ लिया है कि इससे विद्यार्थी का खाता और डेटा हट जाएगा",
  "gw.submit": "सहमति वापस लें और खाता हटाएँ",
  "gw.done.title": "सहमति वापस ले ली गई",
  "gw.done.text": "हमने विद्यार्थी का खाता और डेटा हटा दिया है, और इसकी पुष्टि के लिए आप दोनों को ईमेल कर दिया है।",
  "gw.invalid": "यह लिंक मान्य नहीं है या पहले ही इस्तेमाल हो चुका है।",
  "rel.mother": "माँ",
  "rel.father": "पिता",
  "rel.guardian": "कानूनी अभिभावक",
  "rel.other": "अन्य",
  "edu.none": "कोई औपचारिक स्कूली शिक्षा नहीं",
  "edu.primary": "प्राइमरी स्कूल",
  "edu.secondary": "सेकेंडरी स्कूल",
  "edu.some_university": "विश्वविद्यालय की कुछ पढ़ाई",
  "edu.bachelor": "बैचलर डिग्री",
  "edu.master": "मास्टर डिग्री",
  "edu.doctorate": "डॉक्टरेट",
  "edu.unknown": "पता नहीं",
  "acct.greeting": "नमस्ते, {name}",
  "acct.greetingNoName": "फिर से स्वागत है",
  "acct.hero.title": "जहाँ छोड़ा था, वहीं से आगे बढ़ें",
  "acct.hero.text": "आपकी विश्वविद्यालयों की सूची, वीज़ा चेकलिस्ट और फ़ंडिंग ट्रैकर प्लानर में हैं।",
  "acct.status": "स्थिति",
  "acct.consent": "माता-पिता या अभिभावक की सहमति",
  "acct.consentGranted": "मंज़ूर",
  "acct.freePlan": "मुफ़्त प्लान",
  "acct.seePlans": "प्लान देखें",
  "acct.pass": "{plan} पास",
  "acct.validUntil": "{date} तक मान्य",
  "acct.mfa": "दो-चरणीय साइन-इन",
  "acct.mfaNudge": "हम दो-चरणीय साइन-इन चालू करने की सलाह देते हैं, ताकि चोरी हुआ पासवर्ड आपके खाते में घुसने के लिए काफ़ी न हो।",
  "acct.inbox": "आवेदन इनबॉक्स",
  "acct.inboxNone": "अपना पता पाएँ",
  "acct.withApply": "आवेदन और आगमन पास में शामिल",
  "acct.extension": "Chrome एक्सटेंशन",
  "acct.extensionOn": "कनेक्ट है",
  "acct.extensionAdd": "Chrome में जोड़ें",
  "acct.extensionSetUp": "सेट अप करें",
  "acct.you": "आपका खाता",
  "acct.groupApply": "आवेदन",
  "acct.groupYou": "आप और आपका प्लान",
  "acct.groupSafety": "गोपनीयता और सुरक्षा",
  "acct.groupPlanner": "प्लानर में",
  "acct.profileSub": "आपकी जानकारी, जो आपके आवेदनों में भरी जाती है",
  "acct.familySub": "माता-पिता के लिए प्रगति पेज, और माता-पिता द्वारा भुगतान",
  "acct.dataSub": "सब कुछ डाउनलोड करें या मिटाएँ",
  "acct.mfaShort": "दो-चरणीय",
  "acct.tools": "टूल और सेटिंग",
  "acct.toolsSub": "पढ़ाई की योजना, दस्तावेज़, तारीख़ें, भाषा अभ्यास और लाइट या डार्क रूप",
  "portal.label": "मुख्य",
  "portal.home": "होम",
  "portal.explore": "एक्सप्लोर",
  "portal.apply": "आवेदन",
  "portal.account": "खाता",
  "acct.apps": "आवेदन",
  "acct.appsEmpty": "प्लानर में विश्वविद्यालय जोड़ने के बाद आपके आवेदन यहाँ दिखेंगे।",
  "acct.submitted": "{date} को जमा किया गया",
  "acct.tasks": "करने के काम",
  "acct.tasksEmpty": "अभी करने को कुछ नहीं है।",
  "acct.due": "अंतिम तिथि {date}",
  "acct.manage": "आपका खाता",
  "acct.loadError": "यह हिस्सा लोड नहीं हो सका। {retry}",
  "task.ai": "AI",
  "task.aiFull": "AI का सुझाव",
  "task.email": "आपके इनबॉक्स से",
  "task.error": "यह टास्क अपडेट नहीं हो सका। फिर से कोशिश करें।",
  "app.planned": "योजना में",
  "app.in_progress": "जारी है",
  "app.submitted": "जमा किया गया",
  "app.decision_admitted": "प्रवेश मिला",
  "app.decision_denied": "प्रवेश नहीं मिला",
  "app.decision_waitlisted": "वेटलिस्ट में",
  "app.decision_deferred": "स्थगित",
  "app.accepted": "ऑफ़र स्वीकार किया",
  "app.declined": "ऑफ़र अस्वीकार किया",
  "app.withdrawn": "वापस लिया गया",
  "profile.title": "प्रोफ़ाइल",
  "profile.lead": "इसे एक बार भरें। एक्सटेंशन इसका इस्तेमाल करके आवेदन पोर्टल भरता है, और जमा करने से पहले सब कुछ आप जाँचते हैं।",
  "profile.sec.name": "आपका नाम",
  "profile.nameNote": "अपने नाम ठीक वैसे ही लिखें, जैसे वे आपके पासपोर्ट में लिखे हैं।",
  "f.given_name": "पहला नाम",
  "f.middle_name": "बीच का नाम",
  "f.family_name": "सरनेम",
  "f.preferred_name": "पसंदीदा नाम",
  "profile.sec.about": "आपके बारे में",
  "f.dob": "जन्म तिथि",
  "f.gender": "लिंग",
  "gender.female": "महिला",
  "gender.male": "पुरुष",
  "gender.another": "अन्य लिंग",
  "gender.none": "बताना पसंद नहीं",
  "profile.sec.citizenship": "नागरिकता और निवास",
  "f.citizenship1": "नागरिकता",
  "f.citizenship2": "दूसरी नागरिकता",
  "f.birth_country": "जन्म का देश",
  "f.home_country": "निवास का देश",
  "f.home_countryHint": "कीमतों और वीज़ा चेकलिस्ट के लिए इसका इस्तेमाल होता है।",
  "f.first_language": "पहली भाषा",
  "profile.sec.contact": "संपर्क",
  "f.phone": "फ़ोन",
  "f.phoneHint": "अपने देश का कोड भी लिखें, जैसे ⁦+971⁩।",
  "f.line1": "पता लाइन 1",
  "f.line2": "पता लाइन 2",
  "f.city": "शहर",
  "f.region": "राज्य, प्रांत या क्षेत्र",
  "f.postal_code": "पोस्टल कोड",
  "f.country": "देश",
  "profile.sec.study": "आपको क्या पढ़ना है",
  "f.level": "स्तर",
  "level.foundation": "फ़ाउंडेशन वर्ष",
  "level.diploma": "डिप्लोमा या सर्टिफ़िकेट",
  "level.bachelor": "बैचलर डिग्री",
  "level.master": "मास्टर डिग्री",
  "level.phd": "पीएचडी",
  "f.field": "विषय या मेजर",
  "f.start_term": "आपको कब शुरू करना है",
  "term.label": "{month} {year}",
  "f.budget_usd": "अमेरिकी डॉलर में सालाना बजट",
  "f.budgetHint": "ट्यूशन फ़ीस और रहने का खर्च मिलाकर।",
  "profile.sec.english": "अंग्रेज़ी",
  "f.english_first": "अंग्रेज़ी मेरी पहली भाषा है",
  "f.english_type": "अंग्रेज़ी टेस्ट",
  "test.none": "अभी नहीं दिया",
  "test.other": "कोई दूसरा टेस्ट",
  "f.english_score": "स्कोर",
  "f.english_date": "टेस्ट की तारीख",
  "profile.sec.passport": "पासपोर्ट",
  "f.passport_number": "पासपोर्ट नंबर",
  "f.passportHint": "वैकल्पिक। एन्क्रिप्ट करके सेव किया जाता है। एक्सटेंशन इसे कभी नहीं भरता।",
  "profile.sec.family": "परिवार",
  "profile.familyLead": "आवेदन पोर्टल अक्सर आपके माता-पिता या अभिभावकों के बारे में पूछते हैं।",
  "profile.familyItem": "माता-पिता या अभिभावक {n}",
  "f.member_name": "नाम",
  "f.relation": "रिश्ता",
  "f.education": "सबसे ऊँची शिक्षा",
  "f.occupation": "पेशा",
  "profile.familyAdd": "माता-पिता या अभिभावक जोड़ें",
  "profile.sec.schools": "शिक्षा संस्थान",
  "profile.schoolsLead": "आपका सेकेंडरी स्कूल और कोई भी विश्वविद्यालय, जहाँ आपने पढ़ाई की है।",
  "profile.schoolItem": "संस्थान {n}",
  "f.school_name": "संस्थान का नाम",
  "f.start_date": "कब शुरू किया",
  "f.end_date": "कब पूरा किया, या कब पूरा होने की उम्मीद है",
  "f.test_type": "अंतिम परीक्षा या योग्यता",
  "f.test_typeHint": "उदाहरण के लिए WAEC, CBSE, IGCSE या Tawjihi।",
  "f.test_score": "रिज़ल्ट",
  "profile.schoolAdd": "संस्थान जोड़ें",
  "profile.schoolNameRequired": "संस्थान का नाम जोड़ें, या यह संस्थान हटाएँ।",
  "profile.sec.sensitive": "छात्रवृत्ति मिलान",
  "profile.sensitiveLead": "वैकल्पिक। कुछ छात्रवृत्तियाँ सिर्फ़ खास पृष्ठभूमि वाले विद्यार्थियों के लिए होती हैं। आप चाहें तो इनमें से हर जानकारी अलग से शेयर कर सकते हैं।",
  "profile.sensitivePurpose": "इसका इस्तेमाल सिर्फ़ उन छात्रवृत्तियों से आपका मिलान करने के लिए होता है जो यह जानकारी माँगती हैं। इसे कभी आवेदन पोर्टल पर नहीं भेजा जाता, और कभी मार्केटिंग के लिए इस्तेमाल नहीं किया जाता।",
  "profile.consent.race": "छात्रवृत्ति मिलान के लिए मेरी नस्ल या जातीयता का इस्तेमाल करें",
  "profile.consent.religion": "छात्रवृत्ति मिलान के लिए मेरे धर्म का इस्तेमाल करें",
  "profile.consent.family_income": "छात्रवृत्ति मिलान के लिए मेरी पारिवारिक आय का इस्तेमाल करें",
  "f.race": "नस्ल या जातीयता",
  "f.religion": "धर्म",
  "f.family_income": "अमेरिकी डॉलर में सालाना पारिवारिक आय",
  "income.lt10k": "$10,000 से कम",
  "income.10k_25k": "$10,000 से $25,000",
  "income.25k_50k": "$25,000 से $50,000",
  "income.50k_100k": "$50,000 से $100,000",
  "income.gt100k": "$100,000 से ज़्यादा",
  "profile.sensitiveCleared": "सेव करने पर यह हटा दिया जाएगा।",
  "profile.sensitiveMinor": "18 साल से कम उम्र के विद्यार्थियों के लिए उपलब्ध नहीं।",
  "profile.sec.lang": "भाषा",
  "f.lang": "ईमेल की भाषा",
  "profile.saved": "आपकी प्रोफ़ाइल सेव हो गई है।",
  "profile.unsaved": "आपके कुछ बदलाव सेव नहीं हुए हैं।",
  "inbox.title": "आवेदन इनबॉक्स",
  "inbox.lead": "आवेदनों के लिए आपका अपना ईमेल पता। इस पर भेजे गए प्रवेश से जुड़े ईमेल यहाँ छाँटे जाते हैं, और उनसे तारीखें व अगले कदम अलग से निकाल दिए जाते हैं। जब कोई विश्वविद्यालय फ़ैसला भेजता है या कुछ माँगता है, तो हम आपको ईमेल करते हैं।",
  "inbox.upsellTitle": "आवेदन और आगमन पास में शामिल",
  "inbox.upsellText": "आवेदन और आगमन पास के साथ आपको आवेदन पोर्टल पर इस्तेमाल करने के लिए एक PathsAbroad पता मिलता है, और प्रवेश से जुड़े सभी ईमेल एक ही जगह छँटे हुए मिलते हैं।",
  "inbox.seePlans": "प्लान देखें",
  "inbox.address": "आपका इनबॉक्स पता",
  "inbox.copy": "पता कॉपी करें",
  "inbox.howTitle": "इसे कहाँ इस्तेमाल करें",
  "inbox.how1": "आवेदन पोर्टल पर, जैसे Common App पर, इसे अपने ईमेल पते के रूप में इस्तेमाल करें। PathsAbroad एक्सटेंशन इसे आपके लिए भर देता है।",
  "inbox.how2": "बाकी सब के लिए अपना ईमेल ही इस्तेमाल करते रहें।",
  "inbox.how3": "पूरे मैसेज तब तक रखे जाते हैं जब तक आपका पास चालू है, और कम से कम 30 दिन। उसके बाद हम एक छोटा सारांश, तारीखें, लिंक और करने वाले काम रखते हैं। हम अटैचमेंट नहीं रखते, इसलिए दस्तावेज़ विश्वविद्यालय के पोर्टल से डाउनलोड करें।",
  "inbox.messages": "मैसेज",
  "inbox.empty": "अभी तक प्रवेश से जुड़ा कोई ईमेल नहीं आया है। ईमेल आते ही यहाँ दिखने लगते हैं।",
  "inbox.received": "{date} को मिला",
  "inbox.dates": "तारीखें",
  "inbox.links": "लिंक",
  "inbox.actions": "क्या करना है",
  "inbox.viewFull": "पूरा मैसेज देखें",
  "inbox.hideFull": "पूरा मैसेज छिपाएँ",
  "inbox.fullGone": "पूरा मैसेज हटा दिया गया है।",
  "inbox.fullExpires": "यह पूरा मैसेज {date} को हटा दिया जाएगा।",
  "inbox.from": "भेजने वाला",
  "inbox.subject": "विषय",
  "cat.decision": "फ़ैसला",
  "cat.interview_invite": "इंटरव्यू",
  "cat.missing_documents": "छूटे हुए दस्तावेज़",
  "cat.financial_aid": "वित्तीय सहायता",
  "cat.portal_credentials": "पोर्टल लॉगिन",
  "cat.submission_confirmation": "जमा किया गया",
  "cat.housing": "रहने की जगह",
  "cat.visa_documents": "वीज़ा दस्तावेज़",
  "cat.other": "अन्य",
  "decision.admitted": "प्रवेश मिला",
  "decision.denied": "प्रवेश नहीं मिला",
  "decision.waitlisted": "वेटलिस्ट में",
  "decision.deferred": "स्थगित",
  "plans.title": "प्लान",
  "plans.lead": "हर सीज़न में एक बार भुगतान। कोई सब्सक्रिप्शन नहीं।",
  "plans.oneTime": "इस सीज़न के लिए एक बार का भुगतान। अपने-आप रिन्यू नहीं होता।",
  "plans.validFor": "भुगतान के दिन से {months} तक चलता है।",
  "plans.free": "अभी आपके पास यह है",
  "plans.freeTitle": "सब कुछ मुफ़्त है",
  "plans.freeLead": "PathsAbroad में सब कुछ आपके लिए मुफ़्त है। जब कोई छात्र दाख़िला लेता है या साइन अप करता है तो विश्वविद्यालय और छात्र सेवाएँ हमें पैसे देती हैं, छात्र कभी नहीं।",
  "plans.get": "{plan} प्लान लें",
  "plans.owned": "यह {date} तक आपके पास है",
  "plans.ownedNoDate": "यह आपके पास है",
  "plans.bundlePartial": "आपके पास पहले से {plan} प्लान है। आवेदन और आगमन पास बाकी सब जोड़ देता है।",
  "plans.redirecting": "आपको सुरक्षित चेकआउट पर ले जा रहे हैं…",
  "plans.refund": "सारी बिक्री अंतिम है: कोई रिफ़ंड नहीं। अगर आपको कोई ऑफ़र नहीं मिलता, तो आपका पास अगले सीज़न के लिए आगे बढ़ा दिया जाता है।",
  "plans.startNowTitle": "खरीदने से पहले",
  "plans.startNow": "भुगतान होते ही मेरा पास शुरू करें। मुझे पता है कि सारी बिक्री अंतिम है: शुरू होने के बाद इसे रद्द नहीं किया जा सकता और इसका रिफ़ंड नहीं मिलता।",
  "plans.startNowNote": "अगर आपको कोई ऑफ़र नहीं मिलता, तो आपका पास बिना किसी शुल्क के अगले सीज़न में आगे बढ़ा दिया जाता है।",
  "plans.prices": "कीमतें अमेरिकी डॉलर में हैं, जो आपके निवास के देश और आपके पासपोर्ट वाले देशों के हिसाब से तय की गई हैं (कीमत समूह {tier})।",
  "plans.noFees": "PathsAbroad कभी भी विश्वविद्यालय, टेस्ट या वीज़ा की फ़ीस नहीं लेता। ये फ़ीस आप खुद, सीधे भरते हैं।",
  "plans.paidTitle": "धन्यवाद। आपका भुगतान हो गया।",
  "plans.paidWaiting": "हम आपका पास जोड़ रहे हैं। इसमें आमतौर पर कुछ सेकंड लगते हैं।",
  "plans.paidReady": "आपका {plan} पास तैयार है।",
  "plans.paidEmail": "पुष्टि का ईमेल भेजा जा रहा है।",
  "plans.paidSlow": "इसमें सामान्य से ज़्यादा समय लग रहा है। आपका भुगतान सुरक्षित है, और आपका पास जल्द ही यहाँ दिखेगा। एक मिनट बाद यह पेज रीलोड करें।",
  "plans.canceled": "चेकआउट रद्द हो गया। आपसे कोई पैसा नहीं लिया गया है।",
  "plans.receipts": "रसीदें और इनवॉइस",
  "plans.yourPasses": "आपके खरीदे हुए पास",
  "plans.choose": "प्लान चुनें",
  "pass.active": "सक्रिय",
  "pass.expired": "समाप्त",
  "pass.refunded": "रिफ़ंड हो गया",
  "pass.canceled": "रद्द",
  "pass.paidOn": "{date} को भुगतान हुआ",
  "pass.validUntil": "{date} तक मान्य",
  "pass.withdrawUntil": "आप {date} तक अनुबंध से हटकर पूरा रिफ़ंड पा सकते हैं।",
  "pass.withdraw": "यहाँ अनुबंध से हटें",
  "pass.confirmTitle": "इस अनुबंध से हटें?",
  "pass.confirmRefund": "आपको आपके मूल भुगतान तरीके पर पूरा रिफ़ंड मिलेगा।",
  "pass.confirmAccess": "{plan} प्लान का आपका एक्सेस अभी खत्म हो जाएगा।",
  "pass.confirmReceipt": "हम आपको तारीख वाली रसीद ईमेल करेंगे।",
  "pass.confirm": "हटना कन्फ़र्म करें",
  "pass.keep": "मेरा पास रखें",
  "pass.withdrawn": "{date} को रिफ़ंड किया गया। रिफ़ंड आपके मूल भुगतान तरीके पर भेजा जा रहा है।",
  "pass.withdrawOver": "सारी बिक्री अंतिम है: इस पास के अनुबंध से हटा नहीं जा सकता और इसका रिफ़ंड नहीं मिलता।",
  "ai.tag": "AI",
  "ai.tagFull": "AI का इस्तेमाल होता है",
  "ext.title": "Chrome एक्सटेंशन",
  "ext.lead": "PathsAbroad एक्सटेंशन आवेदन पोर्टल पर आपके सेव किए गए जवाब भर देता है, ताकि आपको उन्हें सिर्फ़ एक बार टाइप करना पड़े।",
  "ext.upsell": "एक्सटेंशन आवेदन और आगमन पास के साथ मिलता है।",
  "ext.howTitle": "यह कैसे काम करता है",
  "ext.how1": "इसे Chrome Web Store से Chrome में जोड़ें। बस एक क्लिक लगता है।",
  "ext.how2": "जब तक आप उसी ब्राउज़र में PathsAbroad में साइन इन हैं, यह अपने-आप कनेक्ट रहता है, और साइन आउट करने पर डिसकनेक्ट हो जाता है।",
  "ext.how3": "अपने आवेदन वाले पेज पर “PathsAbroad से भरें” दबाएँ। हर फ़ील्ड जाँचें, फिर खुद जमा करें।",
  "ext.checking": "एक्सटेंशन ढूँढा जा रहा है…",
  "ext.connecting": "इसे आपके खाते से कनेक्ट किया जा रहा है…",
  "ext.addTitle": "PathsAbroad को Chrome में जोड़ें",
  "ext.addText": "Chrome Web Store में बस एक क्लिक, और यह अपने-आप आपके खाते से कनेक्ट हो जाता है। कोई कोड टाइप नहीं करना है।",
  "ext.addButton": "Chrome में जोड़ें",
  "ext.addSoon": "एक्सटेंशन जल्द ही Chrome Web Store पर होगा।",
  "ext.browsers": "कंप्यूटर पर Chrome, Edge, Brave और Chromium पर बने दूसरे ब्राउज़र में काम करता है।",
  "ext.onTitle": "इस ब्राउज़र में कनेक्ट है",
  "ext.onText": "Common App, UCAS, OUAC या uni-assist पर अपना आवेदन खोलें और पेज के नीचे “PathsAbroad से भरें” दबाएँ।",
  "ext.onInstalled": "PathsAbroad इंस्टॉल और कनेक्ट हो गया है।",
  "ext.onBack": "अब आप अपने आवेदन पर लौट सकते हैं।",
  "ext.connected": "कनेक्ट है",
  "ext.errTitle": "एक्सटेंशन कनेक्ट नहीं हुआ",
  "ext.errText": "फिर से कोशिश करें। अगर फिर भी कनेक्ट न हो, तो इसके बजाय पेयरिंग कोड इस्तेमाल करें (नीचे)।",
  "ext.retry": "फिर से कोशिश करें",
  "ext.phoneTitle": "फ़ोन पर PathsAbroad ऐप इस्तेमाल करें",
  "ext.phoneText": "ऐप आपका आवेदन अपने अंदर ही खोलता है और उसे आपके लिए भर देता है। कंप्यूटर पर, एक्सटेंशन को Chrome में जोड़ें।",
  "ext.appStore": "App Store से डाउनलोड करें",
  "ext.playStore": "Google Play पर पाएँ",
  "ext.appSoon": "ऐप जल्द ही App Store और Google Play पर होगा।",
  "ext.otherTitle": "PathsAbroad को Chrome या Edge में खोलें",
  "ext.otherText": "एक्सटेंशन Chrome, Edge और Chromium पर बने दूसरे ब्राउज़र में काम करता है। इसे जोड़ने के लिए इनमें से किसी एक में PathsAbroad खोलें।",
  "ext.inAppTitle": "आप PathsAbroad ऐप में हैं",
  "ext.inAppText": "अपना आवेदन प्लानर से खोलें। यह ऐप के अंदर ही खुलता है, “PathsAbroad से भरें” बटन के साथ। यहाँ आपको एक्सटेंशन की ज़रूरत नहीं है।",
  "ext.fillButton": "PathsAbroad से भरें",
  "ext.codeTitle": "कोड से कनेक्ट करें",
  "ext.codeLead": "सिर्फ़ तब, जब यह अपने-आप कनेक्ट न हो",
  "ext.step2": "नीचे “पेयरिंग कोड पाएँ” पर क्लिक करें।",
  "ext.step3": "एक्सटेंशन खोलें और 10 मिनट के अंदर कोड टाइप करें।",
  "ext.getCode": "पेयरिंग कोड पाएँ",
  "ext.newCode": "नया कोड पाएँ",
  "ext.code": "आपका पेयरिंग कोड",
  "ext.copy": "कोड कॉपी करें",
  "ext.expiresIn": "समाप्त होने में {time} बाकी",
  "ext.expired": "इस कोड की समय-सीमा खत्म हो गई है। नया कोड पाएँ।",
  "ext.oneUse": "हर कोड एक बार ही काम करता है।",
  "ext.minuteLeft": "इस कोड का इस्तेमाल करने के लिए एक मिनट बाकी है।",
  "ext.rulesTitle": "एक्सटेंशन क्या करता है, और क्या नहीं करता",
  "ext.rule1": "यह सपोर्ट किए गए आवेदन पोर्टल पर आपके सेव किए गए जवाब भरता है: Common App, UCAS, OUAC और uni-assist।",
  "ext.ruleEmail": "ईमेल के लिए यह आपका PathsAbroad इनबॉक्स पता भरता है, ताकि विश्वविद्यालयों के ईमेल आपके आवेदन इनबॉक्स में आएँ।",
  "ext.rule2": "हर फ़ील्ड आप जाँचते हैं, और जमा भी आप ही करते हैं।",
  "ext.rule3": "यह कभी भी निबंध या पासवर्ड नहीं भरता।",
  "ext.rule4": "यह कभी भी जमा करने या भुगतान करने वाले बटन पर क्लिक नहीं करता।",
  "ext.rule5": "यह वीज़ा और सरकारी वेबसाइटों पर काम नहीं करता।",
  "ext.notAffiliated": "PathsAbroad का Common App, UCAS, OUAC, uni-assist या किसी भी विश्वविद्यालय से कोई संबंध नहीं है।",
  "sec.title": "साइन-इन और सुरक्षा",
  "sec.mfaTitle": "दो-चरणीय साइन-इन",
  "sec.mfaOffText": "इसके चालू होने पर, हर बार साइन इन करते समय आपको ऑथेंटिकेटर ऐप से एक कोड टाइप करना होता है, ताकि चोरी हुआ पासवर्ड काफ़ी न हो।",
  "sec.mfaOnText": "हर बार साइन इन करते समय आपको अपने ऑथेंटिकेटर ऐप से एक कोड टाइप करना होता है।",
  "sec.mfaTurnOn": "दो-चरणीय साइन-इन चालू करें",
  "sec.mfaStep1": "कोई ऑथेंटिकेटर ऐप इंस्टॉल करें, जैसे Google Authenticator, Microsoft Authenticator या 1Password।",
  "sec.mfaStep2": "इस QR कोड को ऐप से स्कैन करें।",
  "sec.mfaQr": "आपके ऑथेंटिकेटर ऐप के लिए QR कोड",
  "sec.mfaOpenApp": "इसी फ़ोन पर हैं? इसे अपने ऑथेंटिकेटर ऐप में खोलें",
  "sec.mfaKey": "स्कैन नहीं हो रहा? इसके बजाय ऐप में यह कुंजी टाइप करें:",
  "sec.mfaCopyKey": "कुंजी कॉपी करें",
  "sec.mfaStep3": "ऐप में दिख रहा 6 अंकों का कोड टाइप करें।",
  "sec.mfaVerify": "चालू करें",
  "sec.mfaEnabled": "दो-चरणीय साइन-इन चालू है।",
  "sec.mfaTurnOff": "बंद करें",
  "sec.mfaConfirmOff": "दो-चरणीय साइन-इन बंद करें? तब साइन इन करने के लिए सिर्फ़ आपका पासवर्ड काफ़ी होगा।",
  "sec.mfaKeepOn": "चालू रखें",
  "sec.mfaDisabled": "दो-चरणीय साइन-इन बंद है।",
  "sec.pwTitle": "पासवर्ड",
  "sec.pwNew": "नया पासवर्ड",
  "sec.pwConfirm": "इसे फिर से टाइप करें",
  "sec.pwSubmit": "पासवर्ड बदलें",
  "sec.pwDone": "आपका पासवर्ड बदल दिया गया है।",
  "sec.signoutTitle": "साइन आउट करें",
  "sec.signoutText": "इस ब्राउज़र में PathsAbroad से साइन आउट करें।",
  "data.title": "आपका डेटा",
  "data.lead": "आप देख सकते हैं कि हमारे पास आपके बारे में क्या जानकारी है, उसकी कॉपी अपने साथ ले जा सकते हैं, या उसे हटा सकते हैं।",
  "data.exportTitle": "मेरा डेटा डाउनलोड करें",
  "data.exportText": "एक JSON फ़ाइल, जिसमें आपके बारे में हमारे पास मौजूद सब कुछ है: प्रोफ़ाइल, आवेदन, इनबॉक्स सारांश, टास्क, सहमतियाँ और भुगतान।",
  "data.exportDone": "आपका डाउनलोड शुरू हो गया है।",
  "data.deleteTitle": "मेरा खाता हटाएँ",
  "data.deleteWhat": "इससे ये हट जाएँगे:",
  "data.delete1": "आपका खाता और साइन-इन",
  "data.delete2": "आपकी प्रोफ़ाइल, परिवार की जानकारी, शिक्षा संस्थान और निबंध",
  "data.delete3": "आपका प्लानर, आवेदन और टास्क",
  "data.delete4": "आपका आवेदन इनबॉक्स और उसके मैसेज",
  "data.delete5": "सहमति के रिकॉर्ड और एक्सटेंशन कनेक्शन",
  "data.deleteKept": "टैक्स और धोखाधड़ी-रोधी कानूनों के तहत ज़रूरी होने के कारण, Stripe भुगतान के रिकॉर्ड (रकम, तारीख, कार्ड के आखिरी चार अंक) रखता है। हम एक रिकॉर्ड रखते हैं कि खाता हटाया गया था, जिसमें कोई निजी जानकारी नहीं होती।",
  "data.deleteFinal": "इसे पहले जैसा नहीं किया जा सकता। बेहतर होगा कि आप पहले अपना डेटा डाउनलोड कर लें।",
  "data.deleteType": "कन्फ़र्म करने के लिए DELETE टाइप करें",
  "data.deleteButton": "मेरा खाता हटाएँ",
  "data.rightsTitle": "आपके अधिकार",
  "data.rightAccess": "“मेरा डेटा डाउनलोड करें” से अपने डेटा की कॉपी पाएँ।",
  "data.rightCorrect": "अपनी {profile} में बदलाव करके इसे ठीक करें।",
  "data.rightDelete": "“मेरा खाता हटाएँ” से इसे हटाएँ।",
  "data.rightWithdraw": "अपनी प्रोफ़ाइल में छात्रवृत्ति मिलान वाली किसी भी जानकारी से टिक हटाकर सहमति वापस लें।",
  "data.rightObject": "हम आपके डेटा का इस्तेमाल कैसे करते हैं, इस पर आपत्ति करें या इसे सीमित करें।",
  "data.rightPort": "अपना डेटा किसी दूसरी सेवा में ले जाएँ: डाउनलोड एक स्टैंडर्ड JSON फ़ाइल है।",
  "data.rightComplain": "अपने डेटा सुरक्षा प्राधिकरण से शिकायत करें।",
  "data.contact": "कोई सवाल या अनुरोध? {email} पर ईमेल करें। हम एक महीने के अंदर जवाब देते हैं।",
  "data.profileLink": "प्रोफ़ाइल",
  "bye.title": "आपका खाता हटा दिया गया है",
  "bye.text": "हमने आपका PathsAbroad खाता और डेटा हटा दिया है। PathsAbroad आज़माने के लिए धन्यवाद, और आपकी पढ़ाई के लिए शुभकामनाएँ।",
  "nf.title": "हमें वह पेज नहीं मिल रहा",
  "nf.text": "हो सकता है लिंक टूटा हुआ हो, या पेज कहीं और चला गया हो।",
  "legal.contents": "विषय-सूची",
  "legal.effective": "लागू होने की तारीख: {date}",
  "legal.top": "सबसे ऊपर जाएँ",
  "err.ai_unavailable": "AI अभी उपलब्ध नहीं है। बाद में फिर से कोशिश करें।",
  "aiCheck.title": "क्या यह PathsAbroad के AI ने लिखा है?",
  "aiCheck.lead": "कोई टेक्स्ट पेस्ट करके जाँचें कि क्या वह PathsAbroad के AI गाइड या निबंध फ़ीडबैक का जवाब है। हर AI जवाब लिखे जाते समय चिह्नित किया जाता है, और हम उसका फ़िंगरप्रिंट रखते हैं (टेक्स्ट कभी नहीं)।",
  "aiCheck.label": "जाँचने के लिए टेक्स्ट",
  "aiCheck.hint": "पूरा जवाब ठीक वैसे ही पेस्ट करें जैसा वह दिखाया गया था। बदला हुआ या अधूरा टेक्स्ट मेल नहीं खाएगा।",
  "aiCheck.empty": "जाँचने के लिए कोई टेक्स्ट पेस्ट करें।",
  "aiCheck.submit": "जाँचें",
  "aiCheck.yes.title": "हाँ: यह PathsAbroad के AI ने लिखा है",
  "aiCheck.yes.text": "यह टेक्स्ट {date} को PathsAbroad के AI के एक जवाब से मेल खाता है।",
  "aiCheck.no.title": "कोई मेल नहीं",
  "aiCheck.no.text": "यह टेक्स्ट PathsAbroad के AI के किसी जवाब से मेल नहीं खाता। हो सकता है इसे किसी इंसान ने लिखा हो, इसे बदला गया हो, या इसे किसी और टूल ने लिखा हो।",
  "aiCheck.how": "यह कैसे काम करता है: हर AI जवाब के साथ हस्ताक्षरित जानकारी होती है (किसने लिखा, कब, और टेक्स्ट का फ़िंगरप्रिंट)। यह जाँच आपके पेस्ट किए गए टेक्स्ट के फ़िंगरप्रिंट की तुलना PathsAbroad के AI जवाबों के फ़िंगरप्रिंट से करती है। इसमें छात्र के बारे में कुछ भी नहीं दिखाया जाता।",
  "nav.reminders": "रिमाइंडर",
  "rem.title": "रिमाइंडर",
  "rem.lead": "हम आपको अंतिम तिथियों, ऑफ़र के जवाब, कमी वाले दस्तावेज़ों और फ़ैसलों के बारे में ईमेल करते हैं। आप ये WhatsApp पर भी पा सकते हैं।",
  "rem.on": "चालू",
  "rem.waTitle": "WhatsApp रिमाइंडर",
  "rem.waOff": "WhatsApp रिमाइंडर अभी उपलब्ध नहीं हैं। ईमेल रिमाइंडर अभी काम करते हैं।",
  "rem.waOn": "रिमाइंडर WhatsApp पर {phone} पर जाते हैं।",
  "rem.waPhone": "आपका WhatsApp नंबर",
  "rem.waPhoneHint": "देश के कोड के साथ, जैसे +91 98765 43210।",
  "rem.waConsent": "मुझे PathsAbroad से मेरे आवेदनों के बारे में WhatsApp संदेश (अंतिम तिथियाँ, ऑफ़र के जवाब, कमी वाले दस्तावेज़ और फ़ैसले) और मेरा नंबर कन्फ़र्म करने के लिए एक कोड भेजें। STOP लिखकर जवाब देने पर ये कभी भी बंद हो जाएँगे।",
  "rem.waConsentNeeded": "WhatsApp रिमाइंडर के लिए सहमति देने हेतु बॉक्स पर टिक करें।",
  "rem.waSend": "कोड भेजें",
  "rem.waSent": "हमने WhatsApp पर {phone} पर 6 अंकों का कोड भेजा है। यह 10 मिनट तक काम करेगा।",
  "rem.waCode": "WhatsApp पर आया कोड",
  "rem.waConfirm": "कन्फ़र्म करें",
  "rem.waResend": "नया कोड भेजें",
  "rem.waOther": "दूसरा नंबर इस्तेमाल करें",
  "rem.waConfirmed": "WhatsApp रिमाइंडर चालू हो गए हैं। हमने {phone} पर पहला संदेश भेजा है।",
  "rem.waStop": "WhatsApp रिमाइंडर बंद करें",
  "rem.waStopped": "WhatsApp रिमाइंडर बंद हैं। हमने आपका नंबर मिटा दिया है।",
  "rem.waStoppedReply": "आपने STOP लिखकर WhatsApp रिमाइंडर बंद कर दिए। हमने आपका नंबर मिटा दिया है।",
  "rem.waUnreachable": "WhatsApp {phone} पर संदेश नहीं पहुँचा सका। नंबर जाँचें और इसे फिर से सेट करें।",
  "rem.waChanged": "आपका WhatsApp नंबर बदल गया है, इसलिए {phone} पर रिमाइंडर बंद हो गए हैं। रिमाइंडर पाते रहने के लिए अपना नया नंबर जोड़ें।",
  "rem.phoneInvalid": "अपना WhatsApp नंबर देश के कोड के साथ डालें, जैसे +91 98765 43210।",
  "rem.phoneNotMobile": "मोबाइल नंबर डालें।",
  "rem.phoneNotWhatsApp": "इस नंबर पर WhatsApp संदेश नहीं आ सकते। इसे जाँचें, या ईमेल रिमाइंडर इस्तेमाल करें।",
  "rem.emailTitle": "ईमेल",
  "rem.emailLabel": "{email} पर ईमेल रिमाइंडर",
  "rem.emailOnDone": "ईमेल रिमाइंडर चालू हैं।",
  "rem.emailOffDone": "ईमेल रिमाइंडर बंद हैं।",
  "rem.kindsTitle": "आपको किन बातों के रिमाइंडर मिलते हैं",
  "rem.kindDeadlines": "अंतिम तिथियाँ",
  "rem.kindDeadlinesDesc": "अंतिम तिथि वाले काम और छात्रवृत्ति की अंतिम तिथियाँ: 7, 3 और 1 दिन पहले, और उसी दिन।",
  "rem.kindOffers": "ऑफ़र के जवाब",
  "rem.kindOffersDesc": "ऑफ़र स्वीकार करने या मना करने की तारीख, आपके प्रवेश ईमेल से।",
  "rem.kindDocuments": "कमी वाले दस्तावेज़",
  "rem.kindDocumentsDesc": "जब कोई विश्वविद्यालय लिखता है कि आपके आवेदन में कुछ कमी है।",
  "rem.kindDecisions": "फ़ैसले",
  "rem.kindDecisionsDesc": "जब कोई विश्वविद्यालय फ़ैसला भेजता है। संदेश में कभी नहीं लिखा जाता कि फ़ैसला क्या है।",
  "rem.when": "रिमाइंडर आपके टाइम ज़ोन ({tz}) में 09:00 से 20:00 के बीच आते हैं।",
  "rem.test": "टेस्ट रिमाइंडर भेजें",
  "rem.testSent": "टेस्ट भेज दिया गया। WhatsApp या अपना ईमेल देखें।",
  "rem.saved": "सहेज लिया गया।",
  "rem.recentTitle": "हाल के रिमाइंडर",
  "rem.recentNone": "अभी तक कोई रिमाइंडर नहीं।",
  "rem.kind.deadline": "अंतिम तिथि",
  "rem.kind.offer_reply": "ऑफ़र का जवाब",
  "rem.kind.missing_documents": "कमी वाले दस्तावेज़",
  "rem.kind.decision": "फ़ैसला",
  "rem.kind.scholarship": "छात्रवृत्ति की अंतिम तिथि",
  "rem.kind.test": "टेस्ट",
  "rem.status.queued": "भेजा जा रहा है",
  "rem.status.sent": "भेजा गया",
  "rem.status.delivered": "पहुँच गया",
  "rem.status.read": "पढ़ा गया",
  "rem.status.failed": "नहीं पहुँचा",
  "rem.channel.whatsapp": "WhatsApp संदेश",
  "rem.channel.email": "ईमेल",
  "rem.privacy": "WhatsApp संदेश Meta के WhatsApp Business Platform से भेजे जाते हैं। आपका नंबर एन्क्रिप्ट करके रखा जाता है और रिमाइंडर बंद करने पर मिटा दिया जाता है। पूरी जानकारी {privacy} में है।",
  "rem.privacyLink": "गोपनीयता सूचना",
  "rem.parentsTitle": "WhatsApp पर माता-पिता",
  "rem.parentsLead": "जिन अभिभावक के साथ आप अपना प्रगति पेज शेयर करते हैं, वे उस पेज पर अपना WhatsApp नंबर जोड़ सकते हैं। उन्हें सिर्फ़ उन्हीं बातों के रिमाइंडर मिलते हैं जो पेज पर दिखती हैं, और पेज बंद करने पर उनके रिमाइंडर भी बंद हो जाते हैं।",
  "rem.parentRow": "अभिभावक ({label})",
  "rem.parentRowNoLabel": "अभिभावक",
  "rem.parentPending": "कोड का इंतज़ार है",
  "rem.parentStop": "बंद करें",
  "rem.parentStoppedDone": "बंद कर दिया गया। उनका नंबर मिटा दिया गया है।",
  "rem.parentLinkStopped": "प्रगति पेज के साथ बंद हुआ",
  "nav.family": "परिवार",
  "fam.title": "परिवार",
  "fam.lead": "अपनी प्रगति माता-पिता के साथ शेयर करें, और एक लिंक भेजें ताकि कोई और आपके पास का भुगतान कर सके। उन्हें क्या दिखे, यह आप तय करते हैं, और आप कभी भी शेयर करना बंद कर सकते हैं।",
  "fam.share.title": "अपनी प्रगति शेयर करें",
  "fam.share.sees": "उन्हें क्या दिखता है",
  "fam.share.see1": "आपके विश्वविद्यालय और हर आवेदन की स्थिति।",
  "fam.share.see2": "आने वाली अंतिम तिथियाँ, अगर आप उन्हें चालू करें।",
  "fam.share.see3": "फ़ैसले, अगर आप उन्हें चालू करें।",
  "fam.share.see4": "आपके पास कौन-से पास हैं।",
  "fam.share.never": "उन्हें आपके निबंध, ईमेल, प्रोफ़ाइल, पासपोर्ट की जानकारी या चैट कभी नहीं दिखते, और वे कुछ भी बदल नहीं सकते।",
  "fam.form.lang": "उनके पेज की भाषा",
  "fam.form.label": "यह किसके लिए है?",
  "fam.form.labelHint": "यह सिर्फ़ आपको दिखता है, जैसे मम्मी या पापा।",
  "fam.form.deadlines": "आने वाली अंतिम तिथियाँ दिखाएँ",
  "fam.form.deadlinesNote": "आपके खुले कामों के शीर्षक, जिनकी कोई अंतिम तिथि है।",
  "fam.form.decisions": "फ़ैसले दिखाएँ",
  "fam.form.decisionsNote": "ऑफ़र, अस्वीकृति और वेटिंग लिस्ट। यह बंद होने पर, जिन आवेदनों पर फ़ैसला आ चुका है वे जमा किए गए दिखते हैं।",
  "fam.form.create": "लिंक बनाएँ",
  "fam.created": "आपका लिंक भेजने के लिए तैयार है।",
  "fam.links.title": "आपके लिंक",
  "fam.links.empty": "अभी कोई लिंक नहीं है।",
  "fam.link.view": "प्रगति पेज",
  "fam.link.pay": "भुगतान लिंक: {plan}",
  "fam.link.for": "{label} के लिए",
  "fam.link.inLang": "{language} में",
  "fam.link.until": "{date} तक काम करेगा",
  "fam.link.opened": "आखिरी बार {date} को खोला गया",
  "fam.link.notOpened": "अभी तक नहीं खोला गया",
  "fam.link.status.active": "चालू",
  "fam.link.status.used": "भुगतान हो गया",
  "fam.link.status.expired": "अवधि खत्म",
  "fam.link.status.revoked": "बंद किया गया",
  "fam.link.copy": "लिंक कॉपी करें",
  "fam.link.whatsapp": "WhatsApp पर भेजें",
  "fam.link.email": "ईमेल से भेजें",
  "fam.link.stop": "शेयर करना बंद करें",
  "fam.link.cancel": "लिंक रद्द करें",
  "fam.link.edit": "वे क्या देखते हैं, इसे बदलें",
  "fam.link.saved": "सेव हो गया।",
  "fam.msg.view": "नमस्ते! आप यहाँ PathsAbroad पर विदेश में पढ़ाई के लिए मेरे आवेदन देख सकते हैं: {url}",
  "fam.msg.viewSubject": "विदेश में पढ़ाई के लिए मेरे आवेदन",
  "fam.msg.pay": "नमस्ते! क्या आप मेरे PathsAbroad {plan} पास का भुगतान करने में मदद कर सकते हैं? यह सुरक्षित भुगतान लिंक है: {url}",
  "fam.msg.paySubject": "मेरे PathsAbroad पास का भुगतान",
  "fam.pay.title": "माता-पिता से भुगतान करने को कहें",
  "fam.pay.lead": "जो भी आपकी पढ़ाई का खर्च उठाते हैं, उन्हें भुगतान लिंक भेजें। वे Stripe से भुगतान करते हैं, और पास आपके खाते में जुड़ जाता है। लिंक 14 दिनों तक, एक बार काम करता है।",
  "fam.pay.plan": "प्लान",
  "fam.pay.create": "भुगतान लिंक बनाएँ",
  "fam.pay.covered": "आपके पास में पहले से हर प्लान शामिल है।",
  "fam.pay.buyer": "भुगतान करने वाले व्यक्ति को रसीद मिलती है। सारी बिक्री अंतिम है: कोई रिफ़ंड नहीं।",
  "fam.tooMany": "इस तरह के 10 लिंक पहले से चालू हैं। पहले उनमें से एक बंद करें।",
  "fam.view.title": "विदेश में पढ़ाई की प्रगति",
  "fam.view.titleName": "{name} की विदेश में पढ़ाई की प्रगति",
  "fam.view.lead": "{name} यह पेज आपके साथ शेयर कर रहे हैं। इसमें दिखता है कि विश्वविद्यालय के हर आवेदन की क्या स्थिति है। यहाँ कुछ भी बदला नहीं जा सकता, और {name} कभी भी शेयर करना बंद कर सकते हैं।",
  "fam.view.leadNoName": "एक छात्र यह पेज आपके साथ शेयर कर रहे हैं। इसमें दिखता है कि विश्वविद्यालय के हर आवेदन की क्या स्थिति है। यहाँ कुछ भी बदला नहीं जा सकता, और छात्र कभी भी शेयर करना बंद कर सकते हैं।",
  "fam.view.unis": "विश्वविद्यालय",
  "fam.view.unisEmpty": "सूची में अभी कोई विश्वविद्यालय नहीं है।",
  "fam.view.deadlines": "आगे क्या है",
  "fam.view.deadlinesEmpty": "अगले कुछ महीनों में कोई अंतिम तिथि नहीं है।",
  "fam.view.due": "अंतिम तिथि {date}",
  "fam.view.decisionsHidden": "इस पेज पर फ़ैसले नहीं दिखाए जाते।",
  "fam.view.passes": "PathsAbroad पास",
  "fam.view.passUntil": "{plan}: {date} तक चालू",
  "fam.view.noPass": "अभी कोई भुगतान किया हुआ पास नहीं है। ज़रूरत हो, तो छात्र आपको भुगतान लिंक भेज सकते हैं।",
  "fam.view.updated": "{date} तक की जानकारी।",
  "fam.view.about": "PathsAbroad छात्रों को विदेश में विश्वविद्यालय चुनने, आवेदन करने, वीज़ा पाने और वहाँ पहुँचकर व्यवस्थित होने में मदद करता है।",
  "fam.view.invalid.title": "यह लिंक अब काम नहीं करता",
  "fam.view.invalid.text": "हो सकता है छात्र ने शेयर करना बंद कर दिया हो, या लिंक की अवधि खत्म हो गई हो। उनसे नया लिंक माँगें।",
  "fam.wa.title": "WhatsApp पर रिमाइंडर",
  "fam.wa.lead": "इस पेज पर कुछ ड्यू होने पर PathsAbroad से WhatsApp संदेश पाएँ। आपको सिर्फ़ उन्हीं बातों के बारे में बताया जाएगा जो {name} ने यहाँ दिखाने के लिए चुनी हैं।",
  "fam.wa.leadNoName": "इस पेज पर कुछ ड्यू होने पर PathsAbroad से WhatsApp संदेश पाएँ। आपको सिर्फ़ उन्हीं बातों के बारे में बताया जाएगा जो स्टूडेंट ने यहाँ दिखाने के लिए चुनी हैं।",
  "fam.wa.phone": "आपका WhatsApp नंबर",
  "fam.wa.phoneHint": "देश के कोड के साथ, जैसे +234 803 123 4567।",
  "fam.wa.consent": "मुझे PathsAbroad से {name} के आवेदनों के बारे में WhatsApp संदेश और मेरा नंबर कन्फ़र्म करने के लिए एक कोड भेजें। STOP लिखकर जवाब देने पर या \"रिमाइंडर बंद करें\" बटन से इन्हें कभी भी बंद किया जा सकता है।",
  "fam.wa.consentNoName": "मुझे PathsAbroad से स्टूडेंट के आवेदनों के बारे में WhatsApp संदेश और मेरा नंबर कन्फ़र्म करने के लिए एक कोड भेजें। STOP लिखकर जवाब देने पर या \"रिमाइंडर बंद करें\" बटन से इन्हें कभी भी बंद किया जा सकता है।",
  "fam.wa.consentNeeded": "WhatsApp रिमाइंडर के लिए सहमति देने हेतु बॉक्स पर टिक करें।",
  "fam.wa.send": "कोड भेजें",
  "fam.wa.sent": "हमने WhatsApp पर {phone} पर 6 अंकों का कोड भेजा है। यह 10 मिनट तक काम करेगा।",
  "fam.wa.code": "WhatsApp पर आया कोड",
  "fam.wa.confirm": "कन्फ़र्म करें",
  "fam.wa.resend": "नया कोड भेजें",
  "fam.wa.other": "दूसरा नंबर इस्तेमाल करें",
  "fam.wa.done": "हो गया। रिमाइंडर WhatsApp पर {phone} पर आएँगे। इन्हें कभी भी बंद करने के लिए STOP लिखकर जवाब दें।",
  "fam.wa.phoneInvalid": "अपना WhatsApp नंबर देश के कोड के साथ डालें, जैसे +234 803 123 4567।",
  "fam.wa.phoneNotMobile": "मोबाइल नंबर डालें।",
  "fam.wa.phoneNotWhatsApp": "इस नंबर पर WhatsApp संदेश नहीं आ सकते। कृपया इसे जाँचें।",
  "fam.wa.badCode": "यह कोड सही नहीं है, या इसकी समय-सीमा खत्म हो गई है। WhatsApp संदेश जाँचें, या नया कोड माँगें।",
  "fam.wa.privacy": "आपका नंबर एन्क्रिप्ट करके रखा जाता है। आपके बंद करने पर, या स्टूडेंट के यह पेज शेयर करना बंद करने पर, इसे मिटा दिया जाता है।",
  "fam.status.applying": "आवेदन तैयार हो रहा है",
  "fam.status.submitted": "जमा किया गया",
  "fam.status.offer": "ऑफ़र",
  "fam.status.offer_conditional": "शर्तों वाला ऑफ़र",
  "fam.status.waitlisted": "वेटिंग लिस्ट में",
  "fam.status.deferred": "फ़ैसला टाला गया",
  "fam.status.not_admitted": "प्रवेश नहीं मिला",
  "fam.status.accepted": "ऑफ़र स्वीकार किया",
  "fam.status.declined": "ऑफ़र अस्वीकार किया",
  "fam.status.withdrawn": "वापस लिया गया",
  "pay.title": "PathsAbroad पास का भुगतान करें",
  "pay.titleName": "{name} के {plan} पास का भुगतान करें",
  "pay.lead": "{name} ने अपने PathsAbroad {plan} पास का भुगतान करने के लिए आपको यह लिंक भेजा है। पास {name} के खाते के लिए है; आपको अपना खाता बनाने की ज़रूरत नहीं है।",
  "pay.leadNoName": "एक छात्र ने अपने PathsAbroad {plan} पास का भुगतान करने के लिए आपको यह लिंक भेजा है। पास उनके खाते के लिए है; आपको अपना खाता बनाने की ज़रूरत नहीं है।",
  "pay.price": "कीमत",
  "pay.oneTime": "एक बार का भुगतान। अपने-आप रिन्यू नहीं होता।",
  "pay.valid": "भुगतान के दिन से {months} तक चलता है।",
  "pay.includes": "इसमें क्या शामिल है",
  "pay.refund": "सारी बिक्री अंतिम है: कोई रिफ़ंड नहीं। अगर छात्र को कोई ऑफ़र नहीं मिलता, तो पास अगले सीज़न के लिए आगे बढ़ा दिया जाता है।",
  "pay.formTitle": "भुगतान",
  "pay.email": "आपका ईमेल",
  "pay.emailHint": "आपकी रसीद के लिए।",
  "pay.country": "आप कहाँ रहते हैं?",
  "pay.startNowTitle": "भुगतान से पहले",
  "pay.startNow": "भुगतान होते ही पास शुरू करें। मुझे पता है कि सारी बिक्री अंतिम है: शुरू होने के बाद इसे रद्द नहीं किया जा सकता और इसका रिफ़ंड नहीं मिलता।",
  "pay.startNowNote": "अगर छात्र को कोई ऑफ़र नहीं मिलता, तो पास बिना किसी शुल्क के अगले सीज़न में आगे बढ़ा दिया जाता है।",
  "pay.submit": "Stripe से {price} का भुगतान करें",
  "pay.secure": "भुगतान Stripe संभालता है। PathsAbroad कभी आपका कार्ड नंबर नहीं देखता।",
  "pay.canceled": "भुगतान रद्द हो गया। आपसे कोई पैसा नहीं लिया गया है।",
  "pay.paid.title": "इस पास का भुगतान हो चुका है",
  "pay.paid.text": "धन्यवाद। पास छात्र के खाते में चालू है, और भुगतान करने वाले व्यक्ति के पास रसीद वाला ईमेल है।",
  "pay.covered.title": "भुगतान की ज़रूरत नहीं",
  "pay.covered.text": "छात्र के पास में यह प्लान पहले से शामिल है।",
  "pay.invalid.title": "यह भुगतान लिंक अब काम नहीं करता",
  "pay.invalid.text": "हो सकता है इसकी अवधि खत्म हो गई हो या इसे रद्द कर दिया गया हो। छात्र से नया लिंक माँगें।",
  "pay.done.title": "धन्यवाद",
  "pay.done.waiting": "आपके भुगतान की पुष्टि हो रही है…",
  "pay.done.ready": "भुगतान हो गया। {plan} पास छात्र के खाते में चालू है। हमने आपको कन्फ़र्मेशन ईमेल भेजा है।",
  "pay.done.slow": "आपका भुगतान हो गया है, लेकिन उसकी पुष्टि में सामान्य से ज़्यादा समय लग रहा है। पुष्टि होने पर हम आपको ईमेल करेंगे।",
  "pay.wd.title": "आपकी खरीद",
  "pay.wd.lead": "आपने {date} को {name} के लिए {plan} पास का भुगतान किया था।",
  "pay.wd.leadNoName": "आपने {date} को PathsAbroad {plan} पास का भुगतान किया था।",
  "pay.wd.until": "आप {date} तक अनुबंध से हटकर पूरा रिफ़ंड पा सकते हैं।",
  "pay.wd.confirm1": "आपको पूरा रिफ़ंड, {price}, उसी कार्ड पर मिलेगा जिससे आपने भुगतान किया था।",
  "pay.wd.confirm2": "छात्र के खाते में पास तुरंत खत्म हो जाएगा।",
  "pay.wd.confirm3": "हम आपको तारीख वाली रसीद ईमेल करेंगे।",
  "pay.wd.keep": "पास रहने दें",
  "pay.wd.done": "{date} को रिफ़ंड किया गया। रिफ़ंड उसी कार्ड पर भेजा जा रहा है जिससे आपने भुगतान किया था।",
  "pay.wd.over": "सारी बिक्री अंतिम है: इस खरीद के अनुबंध से हटा नहीं जा सकता और इसका रिफ़ंड नहीं मिलता।",
  "pay.wd.invalid": "अनुबंध से हटने का यह लिंक मान्य नहीं है।",
  "plans.askParent": "माता-पिता से भुगतान करने को कहें",
  "plans.askParentMinor": "18 से कम उम्र है? माता-पिता या अभिभावक आपके पास का भुगतान कर सकते हैं। उन्हें एक सुरक्षित भुगतान लिंक भेजें।",
  "pass.byParent": "आपके भुगतान लिंक से भुगतान हुआ",
  "land.nav.label": "इस पेज पर",
  "land.nav.money": "छात्रवृत्तियाँ",
  "land.nav.how": "यह कैसे काम करता है",
  "land.nav.features": "सुविधाएँ",
  "land.nav.trust": "गोपनीयता",
  "land.nav.pricing": "यह मुफ़्त है",
  "land.nav.faq": "सवाल",
  "land.nav.demo": "डेमो",
  "land.getStarted": "शुरू करें",
  "land.globe.title": "आप कहाँ जाना चाहते हैं?",
  "land.globe.lead": "ग्लोब पर कहीं भी टैप करें। हम सबसे नज़दीकी विश्वविद्यालय पर ज़ूम करेंगे और दिखाएँगे कि वह कैसा है।",
  "land.globe.search": "कोई शहर, देश या विश्वविद्यालय खोजें",
  "land.globe.none": "कुछ नहीं मिला। कोई शहर, देश या विश्वविद्यालय आज़माएँ।",
  "land.globe.aria": "{unis} विश्वविद्यालयों वाला एक ग्लोब, जो धीरे-धीरे घूमता है। इसे घुमाने के लिए खींचें, ज़ूम करने के लिए ऊपर स्क्रॉल या पिंच करें, और सबसे नज़दीकी विश्वविद्यालय देखने के लिए कहीं भी टैप करें। कीबोर्ड से: तीर वाले बटन इसे घुमाते हैं, + और − ज़ूम करते हैं, और Enter बीच के सबसे नज़दीकी विश्वविद्यालय को दिखाता है।",
  "land.globe.closest": "सबसे नज़दीकी विश्वविद्यालय",
  "land.globe.yourPick": "आपकी पसंद",
  "land.globe.away": "जहाँ आपने टैप किया, वहाँ से {d}",
  "land.globe.here": "ठीक वहीं, जहाँ आपने टैप किया",
  "land.globe.km": "{n} किमी",
  "land.globe.close": "बंद करें",
  "land.globe.rank": "विश्व रैंक",
  "land.globe.notRanked": "रैंक नहीं",
  "land.globe.inCountry": "{country} में",
  "land.globe.rankOf": "{n} में से #{r}",
  "land.globe.cost": "हर साल",
  "land.globe.costOwn": "इसकी ट्यूशन फ़ीस ({year}) और रहने का खर्च",
  "land.globe.costOwn0": "इसकी ट्यूशन फ़ीस और रहने का खर्च",
  "land.globe.costEst": "अनुमान: ट्यूशन फ़ीस और रहने का खर्च",
  "land.globe.admit": "स्वीकृति दर",
  "land.globe.admitYear": "{year} में",
  "land.globe.select": "प्रवेश कितना कठिन है",
  "land.globe.sel.high": "बहुत कठिन",
  "land.globe.sel.mid": "कठिन",
  "land.globe.sel.some": "थोड़ा कठिन",
  "land.globe.sel.low": "कम कठिन",
  "land.globe.sel.open": "खुला प्रवेश",
  "land.globe.selRank": "इसकी विश्व रैंक के आधार पर",
  "land.globe.public": "सरकारी",
  "land.globe.private": "निजी",
  "land.globe.cc": "कम्युनिटी कॉलेज",
  "land.globe.taught": "{country} में पढ़ाई: {langs}",
  "land.globe.students": "{n} छात्र",
  "land.globe.founded": "स्थापना {year}",
  "land.globe.begin": "चलिए शुरू करें",
  "land.globe.demo": "डेमो आज़माएँ",
  "land.globe.again": "कोई और जगह चुनें",
  "land.hero.note": "हर छात्र के लिए मुफ़्त। कोई विज्ञापन नहीं, कोई ट्रैकिंग नहीं।",
  "land.hero.signin": "पहले से खाता है? {link}",
  "land.facts.label": "एक नज़र में PathsAbroad",
  "land.facts.unis": "{countries} देशों में {unis} विश्वविद्यालय",
  "land.facts.langs": "अंग्रेज़ी, अरबी, हिन्दी और इंडोनेशियाई में",
  "land.facts.portals": "Common App, UCAS, OUAC और uni-assist के फ़ॉर्म भरता है",
  "land.facts.ads": "कोई विज्ञापन नहीं, और आपका डेटा कभी बेचा नहीं जाता",
  "land.how.title": "ग्लोब पर एक टैप से विदेश में आपके पहले हफ़्ते तक।",
  "land.how.lead": "सात कदम, एक ऐप। हर कदम पर: आप क्या करते हैं, और PathsAbroad आपके लिए क्या करता है।",
  "land.how.step": "{total} में से कदम {n}",
  "land.how.you": "आप",
  "land.how.s1.title": "वे जगहें चुनें जहाँ आप पढ़ना चाहेंगे",
  "land.how.s1.time": "लगभग एक मिनट",
  "land.how.s1.text": "शुरुआत एक ग्लोब से होती है। चमकते बिंदुओं पर टैप करें, या कोई शहर, देश या विश्वविद्यालय खोजें: {countries} देशों में {unis} विश्वविद्यालय, हर एक अपनी असली जगह पर।",
  "land.how.s1.you": "हर वह जगह टैप करें जो आपका ध्यान खींचे।",
  "land.how.s1.pa": "हर जगह के सबसे पास के विश्वविद्यालय ढूँढता है, सबसे पास वाले पहले, दूरी के साथ।",
  "land.how.s2.title": "पाँच छोटे सवालों के जवाब दें",
  "land.how.s2.time": "लगभग दो मिनट",
  "land.how.s2.text": "आपके और आपके देश, आप जो काम करना चाहते हैं, आपके अंक, आपकी अंग्रेज़ी और आपके बजट के बारे में एक छोटी-सी बातचीत। “सिविल इंजीनियर” कहें, और गाइड वह डिग्री तय कर देता है जो आपको वहाँ तक पहुँचाए।",
  "land.how.s2.you": "अपने शब्दों में जवाब दें, या किसी सुझाव पर टैप करें।",
  "land.how.s2.pa": "आपके जवाबों से एक प्रोफ़ाइल बनाता है, जिसका मिलान हर विश्वविद्यालय से किया जा सके।",
  "land.how.s3.title": "अपने लिए सही विश्वविद्यालय देखें",
  "land.how.s3.time": "तुरंत",
  "land.how.s3.text": "आपके लिए सही विश्वविद्यालय ग्लोब पर चमक उठते हैं, आपके अंकों, बजट और लक्ष्यों के हिसाब से क्रम में। हर एक बताता है कि वह क्यों सही है, एक साल का खर्च कितना है और प्रवेश की आपकी संभावना क्या है, साथ में आपके लिए सही छात्रवृत्तियाँ भी।",
  "land.how.s3.you": "जो पसंद आएँ उन्हें रखें, या कोई भी विश्वविद्यालय जोड़ें। एक मुफ़्त खाता आपकी सूची सेव करता है।",
  "land.how.s3.pa": "आपकी संभावना के बारे में ईमानदार रहता है: संभावित, अच्छा मेल या महत्वाकांक्षी।",
  "land.how.s4.title": "अपनी योजना पर एक-एक कदम आगे बढ़ें",
  "land.how.s4.time": "जैसे-जैसे आप आगे बढ़ें",
  "land.how.s4.text": "होम पर हमेशा आपका अगला कदम और आगे आने वाले काम दिखते हैं: हर विश्वविद्यालय के लिए दस्तावेज़, सिफ़ारिश पत्र, निबंध और फ़ीस, तारीख़ के क्रम में। AI गाइड हर कदम पर आपके साथ रहता है। आपके निबंध आपके अपने नोट्स से शुरू होते हैं, और आपको फ़ीडबैक मिलता है, दोबारा लिखा हुआ निबंध कभी नहीं।",
  "land.how.s4.you": "जब आप तैयार हों, अगला कदम पूरा करें।",
  "land.how.s4.pa": "हर तारीख़ को क्रम में रखता है और, अगर आप चाहें, WhatsApp या ईमेल पर याद दिलाता है।",
  "land.how.s5.title": "सेकंडों में फ़ॉर्म भरें, फिर खुद जमा करें",
  "land.how.s5.time": "हर पेज पर कुछ सेकंड",
  "land.how.s5.text": "Common App, UCAS, OUAC और uni-assist पर “यह पेज भरें” दबाएँ, और PathsAbroad का Chrome एक्सटेंशन वे जवाब भर देता है जो आप पहले दे चुके हैं। हर फ़ील्ड आप खुद जाँचते हैं, अपने निबंध खुद लिखते हैं और जमा करें खुद दबाते हैं।",
  "land.how.s5.you": "हर फ़ील्ड जाँचें, फिर विश्वविद्यालय की अपनी साइट पर जमा करें और भुगतान करें।",
  "land.how.s5.pa": "वही भरता है जो आपने उसे बताया है। आपके निबंध या पासवर्ड कभी नहीं, और जमा करें या भुगतान का बटन कभी नहीं दबाता।",
  "land.how.s6.title": "सारे जवाब एक ही जगह",
  "land.how.s6.time": "जब भी कोई ख़बर आए",
  "land.how.s6.text": "विश्वविद्यालय आपके अपने PathsAbroad पते पर लिखते हैं। फ़ैसले, इंटरव्यू के न्योते और दस्तावेज़ों के अनुरोध आते ही छाँट दिए जाते हैं, और अगला कदम आपकी सूची में जुड़ जाता है। आपका परिवार केवल पढ़ने वाले एक पेज पर आपकी प्रगति देख सकता है।",
  "land.how.s6.you": "ख़बरें पढ़ें और अपने ऑफ़र का जवाब दें।",
  "land.how.s6.pa": "हर ईमेल छाँटता है और उससे तारीख़ें और अगले कदम निकालता है।",
  "land.how.s7.title": "जाने की तैयारी करें",
  "land.how.s7.time": "ऑफ़र मिलने के बाद",
  "land.how.s7.text": "आपकी वीज़ा चेकलिस्ट, आधिकारिक स्रोतों के लिंक के साथ, और साथ में अपने देश और विदेश से फ़ंडिंग, रहने की जगह, खाना, छात्रों के लिए नौकरियाँ और आपके पहले हफ़्ते। सामान्य जानकारी, इमिग्रेशन या कानूनी सलाह नहीं।",
  "land.how.s7.you": "अपना ऑफ़र स्वीकार करें और अपनी सूची पूरी करें।",
  "land.how.s7.pa": "आप जहाँ जा रहे हैं वहाँ के कदम दिखाता है, और जब कोई वीज़ा नियम आपकी राष्ट्रीयता पर असर डाले तो आपको बताता है।",
  "land.money.eyebrow": "छात्रवृत्तियाँ",
  "land.money.title": "पैसा हम ढूँढते हैं। हर छात्रवृत्ति, आपके लिए जाँची हुई।",
  "land.money.lead": "अंतरराष्ट्रीय छात्रों के लिए छात्रवृत्तियाँ सैकड़ों सरकारी और फ़ाउंडेशन वेबसाइटों पर बिखरी हुई हैं। PathsAbroad {countries} देशों में इनमें से {n} को आपकी राष्ट्रीयता, आपके स्तर और आप जहाँ जाना चाहते हैं, उसके हिसाब से जाँचता है, और दिखाता है कि हर एक कितने की है।",
  "land.money.s1": "छात्रवृत्तियाँ और ग्रांट, हर छात्र के लिए जाँची गईं",
  "land.money.s2": "सालाना: इनमें से किसी एक की सबसे बड़ी राशि",
  "land.money.s3": "देश, उनकी सरकारों की छात्रवृत्तियों और बड़ी अंतरराष्ट्रीय संस्थाओं के साथ",
  "land.money.ex_eyebrow": "उदाहरण",
  "land.money.ex_who": "जॉर्डन की अमीना कनाडा, ब्रिटेन या जर्मनी में मास्टर्स करना चाहती हैं",
  "land.money.ex_v": "{n} छात्रवृत्तियाँ जिनके लिए वह आवेदन कर सकती हैं, सालाना {amt} तक की",
  "land.money.peryear": "सालाना {amt}",
  "land.money.eu": "यूरोप",
  "land.money.intl": "अंतरराष्ट्रीय",
  "land.money.cta": "देखें कि आपको कौन-सी छात्रवृत्तियाँ मिल सकती हैं",
  "land.money.fine": "राशियाँ सालाना हैं, हर प्रोग्राम के अपने पेजों से। जहाँ कोई प्रोग्राम “पूरी ट्यूशन फ़ीस” देता है, वहाँ हम उसे आम फ़ीस के हिसाब से आँकते हैं और उसे अनुमान बताते हैं। आम तौर पर छात्रवृत्तियाँ एक साथ नहीं मिलतीं। अक्टूबर 2026 में जाँचा गया।",
  "land.how.d.where": "आप ख़ुद को कहाँ पढ़ते हुए देखते हैं?",
  "land.how.d.continue": "आगे बढ़ें ({n})",
  "land.how.d.guide": "AI गाइड",
  "land.how.d.career": "आप आगे चलकर कौन-सा काम करना चाहते हैं? उसी के आधार पर मैं सही डिग्री तय करूँगा।",
  "land.how.d.civil": "सिविल इंजीनियर",
  "land.how.d.level": "सिविल इंजीनियर बनने के लिए, बैचलर डिग्री के बाद आम तौर पर अगला कदम मास्टर डिग्री होता है। क्या मैं यही चुनूँ?",
  "land.how.d.yes": "हाँ",
  "land.how.d.finding": "आपके लिए सही विश्वविद्यालय ढूँढ रहा हूँ…",
  "land.how.d.scholar": "3 छात्रवृत्तियाँ आपके लिए सही हैं",
  "land.how.d.save": "मेरी सूची सहेजें",
  "land.how.d.next": "अगला: 3 सिफ़ारिश पत्र लें। टैप करें, मैं हर कदम पर आपके साथ रहूँगा।",
  "land.how.d.ask": "पूछें",
  "land.how.d.task": "3 सिफ़ारिश पत्र लें",
  "land.how.d.due": "2 दिन में",
  "land.how.d.doIt": "अभी करें",
  "land.how.d.coming": "आगामी",
  "land.how.d.deadline": "आवेदन की अंतिम तिथि: {school}",
  "land.how.d.inDays": "{n} दिन में",
  "land.how.d.trip": "आपकी यात्रा",
  "land.how.d.starts": "पढ़ाई सितंबर में शुरू होगी",
  "land.how.d.visa": "आपकी वीज़ा चेकलिस्ट",
  "land.features.title": "विदेश में पढ़ाई के लिए सब कुछ, एक ही जगह।",
  "land.features.lead": "एक उदाहरण छात्रा, जॉर्डन की अमीना, के लिए यह ऐसा दिखता है।",
  "land.match.eyebrow": "आपके लिए सही विश्वविद्यालय",
  "land.match.title": "आपके लिए सही विश्वविद्यालय, आपकी संभावना के ईमानदार अनुमान के साथ।",
  "land.match.text": "PathsAbroad को अपने अंक, बजट और लक्ष्य बताएँ। यह आपके लिए सही विश्वविद्यालय सुझाता है, हर एक की सालाना लागत और उसमें आपकी संभावना के साथ: संभावित, अच्छा मेल या महत्वाकांक्षी।",
  "land.match.p1": "देखें कि हर विश्वविद्यालय आपके लिए क्यों सही है, और उसकी लागत कितनी है।",
  "land.match.p2": "आपकी प्रोफ़ाइल से मेल खाती सबसे अच्छी छात्रवृत्तियाँ।",
  "land.match.p3": "कोई भी विश्वविद्यालय जोड़ें, वे भी जो हमने नहीं सुझाए।",
  "land.apply.eyebrow": "आवेदन",
  "land.apply.title": "आवेदन फ़ॉर्म सेकंडों में भरें। जमा खुद करें।",
  "land.apply.text": "जब आप “यह पेज भरें” दबाते हैं, तो PathsAbroad का Chrome एक्सटेंशन आपके सेव किए गए जवाब Common App, UCAS, OUAC और uni-assist में भर देता है। हर फ़ील्ड आप खुद जाँचते हैं।",
  "land.apply.p3": "यह तभी काम करता है जब आप बटन दबाते हैं, और वीज़ा व सरकारी वेबसाइटों पर काम नहीं करता।",
  "land.inbox.eyebrow": "इनबॉक्स",
  "land.inbox.title": "प्रवेश से जुड़ा हर ईमेल, आपके लिए छाँटा हुआ।",
  "land.inbox.text": "आवेदन पोर्टल पर अपना PathsAbroad ईमेल पता इस्तेमाल करें। फ़ैसले, इंटरव्यू के न्योते और दस्तावेज़ों के अनुरोध छाँटे जाते हैं, और अगला कदम आपके करने के कामों में जुड़ जाता है।",
  "land.inbox.p1": "हर ईमेल से तारीख़ें और अगले कदम निकालकर दिखाए जाते हैं।",
  "land.inbox.p2": "हर अंतिम तिथि से पहले रिमाइंडर, अगर आप चाहें।",
  "land.inbox.p3": "पूरे ईमेल 30 दिन तक एन्क्रिप्ट करके रखे जाते हैं, फिर हटा दिए जाते हैं।",
  "land.ai.title": "एक AI गाइड जो समझाता है, और आपकी जगह कभी नहीं लिखता।",
  "land.ai.text": "कोर्स, ख़र्च या वीज़ा के बारे में पूछें और आसान जवाब पाएँ, जिन पर हमेशा AI का निशान होता है। हर निबंध आपके अपने जवाबों से बने नोट्स के साथ शुरू होता है; उसे आप लिखते हैं, फिर फ़ीडबैक पाते हैं, दोबारा लिखा गया निबंध कभी नहीं। AI हर छात्र के लिए मुफ़्त है।",
  "land.reminders.title": "WhatsApp या ईमेल पर रिमाइंडर।",
  "land.reminders.text": "अंतिम तिथि से 7, 3 और 1 दिन पहले, और उसी दिन संदेश पाएँ। इन्हें बंद करने के लिए STOP लिखकर जवाब दें।",
  "land.visa.title": "वीज़ा के कदम और आपके पहले हफ़्ते।",
  "land.visa.text": "हर देश के लिए आधिकारिक स्रोतों के लिंक वाली चेकलिस्ट, फिर रहने की जगह, खाना और छात्रों के लिए नौकरियाँ। सामान्य जानकारी, इमिग्रेशन या कानूनी सलाह नहीं।",
  "land.family.title": "अपने परिवार को साथ रखें।",
  "land.family.text": "माता-पिता या अपनी पसंद के किसी भी व्यक्ति के साथ अपनी प्रगति का एक पेज शेयर करें, जिसे वे सिर्फ़ पढ़ सकें। आप कभी भी शेयर करना बंद कर सकते हैं।",
  "land.lang.title": "आपकी भाषा में।",
  "land.lang.text": "PathsAbroad को अंग्रेज़ी, अरबी, हिन्दी या इंडोनेशियाई में इस्तेमाल करें, और कभी भी भाषा बदलें।",
  "land.trust.title": "छात्रों की सुरक्षा के लिए बना।",
  "land.trust.lead": "पासपोर्ट नंबर, अंक और परिवार की जानकारी, आपकी सबसे निजी जानकारियों में से हैं। PathsAbroad इन्हें ऐसे सुरक्षित रखता है।",
  "land.trust.enc.title": "सेव होने से पहले एन्क्रिप्ट",
  "land.trust.enc.text": "आपका पासपोर्ट नंबर, जन्मतिथि, पारिवारिक आय, प्लानर में सेव की गई हर चीज़ और प्रवेश से जुड़े आपके ईमेल AES-256-GCM से एन्क्रिप्ट किए जाते हैं। डेटाबेस में सिर्फ़ एन्क्रिप्ट किया हुआ रूप ही रखा जाता है।",
  "land.trust.rls.title": "आपके रिकॉर्ड सिर्फ़ आप देख सकते हैं",
  "land.trust.rls.text": "डेटाबेस की हर पंक्ति रो-लेवल सिक्योरिटी से उसके मालिक तक सीमित है, इसलिए कोई भी छात्र किसी दूसरे छात्र का डेटा नहीं पढ़ सकता।",
  "land.trust.redact.title": "निजी जानकारी AI तक नहीं पहुँचती",
  "land.trust.redact.text": "AI को कुछ भी भेजने से पहले पासपोर्ट नंबर, जन्मतिथि, फ़ोन नंबर, ईमेल और पते हटा दिए जाते हैं। नस्ल, धर्म और पारिवारिक आय कभी नहीं भेजी जाती।",
  "land.trust.ai.title": "AI का लिखा हर टेक्स्ट चिह्नित होता है",
  "land.trust.ai.text": "AI जो कुछ भी लिखता है, उस पर AI का निशान होता है, और कोई भी जाँच सकता है कि कोई टेक्स्ट PathsAbroad से आया है या नहीं।",
  "land.trust.aiCheck": "कोई टेक्स्ट जाँचें",
  "land.trust.mfa.text": "ऑथेंटिकेटर ऐप का एक कोड जोड़ें, ताकि चोरी हुआ पासवर्ड काफ़ी न हो।",
  "land.trust.help.title": "ज़रूरत के समय मदद",
  "land.trust.help.text": "अगर किसी संदेश से लगे कि कोई ख़तरे में हो सकता है, तो AI गाइड उसके देश की संकट हेल्पलाइनों के साथ जवाब देता है।",
  "land.trust.data.title": "आपका डेटा, आपकी मर्ज़ी",
  "land.trust.data.text": "कभी भी अपना सारा डेटा डाउनलोड करें, या अपना खाता हटाएँ। कुछ भी बेचा नहीं जाता और न ही विज्ञापन के लिए इस्तेमाल होता है।",
  "land.price.title": "हर छात्र के लिए मुफ़्त।",
  "land.price.lead": "कोई पास नहीं, कोई सब्सक्रिप्शन नहीं, कोई कार्ड नहीं। दूसरे देश में पढ़ने जा रहे छात्रों के लिए PathsAbroad में सब कुछ मुफ़्त है।",
  "land.price.from": "आप कहाँ से हैं?",
  "land.price.to": "आप कहाँ पढ़ना चाहते हैं?",
  "land.price.chooseFrom": "अपना देश चुनें",
  "land.price.chooseTo": "देश चुनें",
  "land.price.notSure": "अभी तय नहीं",
  "land.price.pick": "अपनी क़ीमत देखने के लिए दोनों सवालों के जवाब दें।",
  "land.price.yours": "{country} में पढ़ाई के लिए आपकी क़ीमत",
  "land.price.yoursAny": "आपकी क़ीमत",
  "land.price.freeNote": "सब कुछ, बिना किसी समय सीमा के",
  "land.price.how": "हमारी कमाई कैसे होती है: कुछ विश्वविद्यालय और छात्र सेवाएँ (लोन, रहने की जगह, ब्लॉक्ड अकाउंट) PathsAbroad को तब फ़ीस देती हैं जब कोई छात्र हमारे ज़रिए दाख़िला लेता है या साइन अप करता है। इससे आपको कभी कुछ ज़्यादा नहीं देना पड़ता, और आपके मैच कभी नहीं बदलते: वे सिर्फ़ इस बात पर तय होते हैं कि हर विश्वविद्यालय आपके लिए कितना सही है।",
  "land.price.abroad": "PathsAbroad अपने देश से बाहर पढ़ाई के लिए है, इसलिए हम आपके अपने देश के विश्वविद्यालय नहीं दिखाते।",
  "land.price.for": "एक बार भुगतान, {months} तक मान्य",
  "land.price.usd": "क़ीमतें अमेरिकी डॉलर में हैं, और भुगतान से पहले आपको हमेशा अपनी क़ीमत दिखती है।",
  "land.price.parents": "माता-पिता एक सुरक्षित लिंक से आपके लिए भुगतान कर सकते हैं।",
  "land.cta.free": "मुफ़्त में शुरू करें",
  "land.cta.planner": "प्लानर आज़माएँ",
  "land.faq.title": "सवाल और जवाब।",
  "land.faq.q1": "क्या PathsAbroad मुफ़्त है?",
  "land.faq.a1": "हाँ, पूरी तरह: विश्वविद्यालयों की खोज, आपकी संभावना, AI गाइड, ऑटोपायलट, निबंध मदद, हर छात्रवृत्ति का आवेदन, Chrome एक्सटेंशन, आवेदन इनबॉक्स, और वीज़ा और आगमन में मदद। हमें विश्वविद्यालय और छात्र सेवाएँ पैसे देती हैं, छात्र कभी नहीं।",
  "land.faq.q2": "क्या PathsAbroad मेरी ओर से आवेदन करता है?",
  "land.faq.a2": "नहीं। आप खुद अपने विश्वविद्यालय चुनते हैं, अपने निबंध लिखते हैं, और हर आवेदन खुद जमा करते हैं और उसका भुगतान करते हैं। PathsAbroad आपकी सेव की गई जानकारी भरता है, हर निबंध आपके जवाबों से बने नोट्स के साथ शुरू करता है और आपके काम व्यवस्थित रखता है।",
  "land.faq.q3": "क्या यह इमिग्रेशन या कानूनी सलाह है?",
  "land.faq.a3": "नहीं। वीज़ा की जानकारी आधिकारिक स्रोतों से जुड़ी है और सामान्य जानकारी है, इमिग्रेशन या कानूनी सलाह नहीं। अपनी स्थिति के लिए हमेशा आधिकारिक वेबसाइट देखें।",
  "land.faq.q4": "मुझे कौन-से विश्वविद्यालय मिल सकते हैं?",
  "land.faq.a4": "{countries} देशों में {unis} विश्वविद्यालय, जिनमें अमेरिका, ब्रिटेन, कनाडा, ऑस्ट्रेलिया और जर्मनी शामिल हैं। PathsAbroad विदेश में पढ़ाई के लिए है, इसलिए आपके अपने देश के विश्वविद्यालय नहीं दिखाए जाते। आप कोई भी विश्वविद्यालय ख़ुद भी जोड़ सकते हैं।",
  "land.faq.q5": "अगर मेरी उम्र 18 से कम हो, तो क्या होगा?",
  "land.faq.a5": "आपकी जानकारी सेव होने से पहले माता-पिता या अभिभावक आपके खाते को मंज़ूरी देते हैं, और प्रोफ़ाइल के कुछ संवेदनशील सवाल बंद रहते हैं।",
  "land.faq.q6": "PathsAbroad पैसे कैसे कमाता है?",
  "land.faq.a6": "कुछ विश्वविद्यालय और छात्र सेवाएँ हमें तब फ़ीस देती हैं जब कोई छात्र PathsAbroad के ज़रिए दाख़िला लेता है या साइन अप करता है। आप हमें कभी कुछ नहीं देते, और यह फ़ीस कभी नहीं बदलती कि हम आपको किन विश्वविद्यालयों से मिलाते हैं।",
  "land.faq.q7": "क्या मेरे माता-पिता मेरी प्रगति देख सकते हैं?",
  "land.faq.a7": "सिर्फ़ तभी, जब आप चाहें। आप माता-पिता या अभिभावक के साथ एक पेज शेयर कर सकते हैं, जिसे वे सिर्फ़ पढ़ सकें, और कभी भी शेयर करना बंद कर सकते हैं।",
  "land.faq.q8": "मेरे डेटा का क्या होता है?",
  "land.faq.a8": "संवेदनशील जवाब एन्क्रिप्ट किए जाते हैं, और कुछ भी बेचा या विज्ञापन के लिए इस्तेमाल नहीं किया जाता। आप अपने खाते से सब कुछ डाउनलोड कर सकते हैं या हटा सकते हैं।",
  "land.final.title": "आज ही अपना रास्ता शुरू करें।",
  "land.final.text": "मुफ़्त खाता बनाएँ, या पहले प्लानर आज़माएँ।",
  "land.demo.example": "उदाहरण",
  "land.demo.matches": "आपके लिए सही विश्वविद्यालय",
  "land.demo.inbox": "आवेदन इनबॉक्स",
  "land.demo.decision": "फ़ैसला",
  "land.demo.nextReply": "अगला कदम आपके कामों में जोड़ा गया",
  "land.demo.whatsapp": "WhatsApp संदेश",
  "land.demo.reminder": "{school} के ऑफ़र का जवाब देने के लिए 3 दिन बाकी हैं।",
  "land.demo.all": "सभी",
  "land.demo.likely": "संभावित",
  "land.demo.fit": "अच्छा मेल",
  "land.demo.ambitious": "महत्वाकांक्षी",
  "land.demo.estimate": "संभावनाएँ अनुमान हैं, वादे नहीं।",
  "land.demo.firstName": "पहला नाम",
  "land.demo.lastName": "उपनाम",
  "land.demo.citizenship": "नागरिकता",
  "land.demo.essay": "निबंध",
  "land.demo.youWrite": "इसे आप लिखते हैं",
  "land.demo.submit": "जमा करें",
  "land.demo.youSubmit": "जमा आप खुद करते हैं",
  "land.demo.fill": "यह पेज भरें",
  "land.demo.filled": "3 फ़ील्ड भरे गए",
  "land.demo.offer": "आपको प्रवेश का ऑफ़र मिला है।",
  "land.demo.interview": "इंटरव्यू",
  "land.demo.interviewText": "अपने इंटरव्यू के लिए समय चुनें।",
  "land.demo.missing": "दस्तावेज़ बाकी है",
  "land.demo.missingText": "अपने अंग्रेज़ी टेस्ट के नतीजे अपलोड करें।",
  "land.demo.todo": "करने के कामों में जोड़ा गया:",
  "land.demo.aiQ": "कंडीशनल ऑफ़र का क्या मतलब है?",
  "land.demo.aiA": "इसका मतलब है कि आपके पत्र में लिखी शर्तें पूरी होते ही विश्वविद्यालय आपको प्रवेश देगा। ये शर्तें आमतौर पर आपके फ़ाइनल अंक या अंग्रेज़ी टेस्ट का स्कोर होती हैं।",
  "land.demo.visa1": "ऑफ़र लेटर",
  "land.demo.visa2": "पैसों का सबूत",
  "land.demo.visa3": "स्वास्थ्य बीमा",
  "land.demo.visa4": "वीज़ा अपॉइंटमेंट बुक करें",
  "land.demo.parentView": "आपके माता-पिता क्या देखते हैं",
  "land.demo.youSee": "आप देखते हैं",
  "land.demo.stored": "डेटाबेस में रखा जाता है",
};
